export type Locale = 'zh-CN' | 'en';

export interface MessageDescriptor {
  'zh-CN': string;
  en: string;
}

export const DEFAULT_LOCALE: Locale = 'zh-CN';
export const SUPPORTED_LOCALES: Locale[] = ['zh-CN', 'en'];

export const messageCatalog: Record<string, MessageDescriptor> = {
  首页: { 'zh-CN': '首页', en: 'Home' },
  用户指南: { 'zh-CN': '用户指南', en: 'Guide' },
  服务预约: { 'zh-CN': '服务预约', en: 'Book Services' },
  管理中心: { 'zh-CN': '管理中心', en: 'Admin Center' },
  个人中心: { 'zh-CN': '个人中心', en: 'Profile' },
  我的订单: { 'zh-CN': '我的订单', en: 'My Orders' },
  退出登录: { 'zh-CN': '退出登录', en: 'Sign Out' },
  登录: { 'zh-CN': '登录', en: 'Sign In' },
  注册: { 'zh-CN': '注册', en: 'Sign Up' },
  登录身份: { 'zh-CN': '登录身份', en: 'Signed in as' },
  返回首页: { 'zh-CN': '返回首页', en: 'Back to Home' },
  打开菜单: { 'zh-CN': '打开菜单', en: 'Open menu' },
  关闭: { 'zh-CN': '关闭', en: 'Close' },
  刷新: { 'zh-CN': '刷新', en: 'Refresh' },
  保存: { 'zh-CN': '保存', en: 'Save' },
  '保存中...': { 'zh-CN': '保存中...', en: 'Saving...' },
  提交: { 'zh-CN': '提交', en: 'Submit' },
  '提交中...': { 'zh-CN': '提交中...', en: 'Submitting...' },
  重置: { 'zh-CN': '重置', en: 'Reset' },
  '加载中...': { 'zh-CN': '加载中...', en: 'Loading...' },
  页面加载失败: { 'zh-CN': '页面加载失败', en: 'Failed to load page' },
  '页面开发中...': { 'zh-CN': '页面开发中...', en: 'Page under construction...' },
  微信二维码: { 'zh-CN': '微信二维码', en: 'WeChat QR code' },
  小红书二维码: { 'zh-CN': '小红书二维码', en: 'RedNote QR code' },
  服务项目: { 'zh-CN': '服务项目', en: 'Services' },
  联系方式: { 'zh-CN': '联系方式', en: 'Contact' },
  服务免责声明: { 'zh-CN': '服务免责声明', en: 'Service Disclaimer' },
  扫码添加微信: { 'zh-CN': '扫码添加微信', en: 'Scan to add us on WeChat' },
  扫码关注小红书: { 'zh-CN': '扫码关注小红书', en: 'Scan to follow us on RedNote' },
  服务定位: { 'zh-CN': '服务定位', en: 'Service Positioning' },
  服务性质声明: { 'zh-CN': '服务性质声明', en: 'Nature of Service' },
  具体服务说明: { 'zh-CN': '具体服务说明', en: 'Service Details' },
  房源代看服务: { 'zh-CN': '房源代看服务', en: 'Property Inspection Assistance' },
  申请协助服务: { 'zh-CN': '申请协助服务', en: 'Application Assistance' },
  房屋检查及跑腿服务: { 'zh-CN': '房屋检查及跑腿服务', en: 'Property Check and Errand Assistance' },
  重要提醒: { 'zh-CN': '重要提醒', en: 'Important Notes' },
  我已阅读并理解: { 'zh-CN': '我已阅读并理解', en: 'I have read and understood' },
  管理员: { 'zh-CN': '管理员', en: 'Administrator' },
  VIP用户: { 'zh-CN': 'VIP用户', en: 'VIP User' },
  高级用户: { 'zh-CN': '高级用户', en: 'Premium User' },
  普通用户: { 'zh-CN': '普通用户', en: 'User' },
  活跃: { 'zh-CN': '活跃', en: 'Active' },
  禁用: { 'zh-CN': '禁用', en: 'Disabled' },
  待处理: { 'zh-CN': '待处理', en: 'Pending' },
  处理中: { 'zh-CN': '处理中', en: 'In Progress' },
  已完成: { 'zh-CN': '已完成', en: 'Completed' },
  已取消: { 'zh-CN': '已取消', en: 'Cancelled' },
  已拒绝: { 'zh-CN': '已拒绝', en: 'Rejected' },
  未知类型: { 'zh-CN': '未知类型', en: 'Unknown Type' },
  无角色: { 'zh-CN': '无角色', en: 'No roles' },
  All_rights_reserved: {
    'zh-CN': '版权所有。',
    en: 'All rights reserved.',
  },
  'app.initFailed': {
    'zh-CN': '应用初始化失败，请刷新页面重试',
    en: 'App initialization failed. Please refresh and try again.',
  },
  'app.unexpectedError': {
    'zh-CN': '发生了意外错误，请稍后重试',
    en: 'An unexpected error occurred. Please try again later.',
  },
  'app.networkError': {
    'zh-CN': '网络连接错误，请检查网络设置',
    en: 'Network error. Please check your connection.',
  },
  'auth.confirmLogout': {
    'zh-CN': '确定要退出登录吗？',
    en: 'Are you sure you want to sign out?',
  },
  'auth.welcomeBack': {
    'zh-CN': '欢迎回来，{{email}}！',
    en: 'Welcome back, {{email}}!',
  },
  'auth.unauthorized': {
    'zh-CN': '无权限访问此页面',
    en: 'You do not have permission to access this page.',
  },
  'common.previous': { 'zh-CN': '上一页', en: 'Previous' },
  'common.next': { 'zh-CN': '下一页', en: 'Next' },
  'common.perPage': { 'zh-CN': '每页', en: 'Per page' },
  'common.records': { 'zh-CN': '条', en: 'rows' },
  'common.pageCount': {
    'zh-CN': '共 {{count}} 页',
    en: '{{count}} pages total',
  },
  'common.paginationInfo': {
    'zh-CN': '显示 {{start}}-{{end}} 条，共 {{total}} 条记录',
    en: 'Showing {{start}}-{{end}} of {{total}} records',
  },
  'common.showingItems': {
    'zh-CN': '显示第 {{start}} - {{end}} 项，共 {{total}} 项',
    en: 'Showing {{start}} - {{end}} of {{total}}',
  },
  'common.zhLabel': { 'zh-CN': '中', en: 'ZH' },
  'common.enLabel': { 'zh-CN': 'EN', en: 'EN' },
  'common.languageSwitcher': { 'zh-CN': '语言切换', en: 'Language' },
};

const patternMessages: Record<string, MessageDescriptor> = {
  'pattern.required': {
    'zh-CN': '{{label}} 是必填项',
    en: '{{label}} is required',
  },
  'pattern.invalidFormat': {
    'zh-CN': '{{label}} 格式不正确',
    en: '{{label}} has an invalid format',
  },
  'pattern.minLength': {
    'zh-CN': '{{label}} 最少需要 {{minLength}} 个字符',
    en: '{{label}} must be at least {{minLength}} characters',
  },
  'pattern.maxLength': {
    'zh-CN': '{{label}} 最多允许 {{maxLength}} 个字符',
    en: '{{label}} must be at most {{maxLength}} characters',
  },
  'pattern.requestFailed': {
    'zh-CN': '请求失败: {{status}}',
    en: 'Request failed: {{status}}',
  },
  'pattern.submittedBy': {
    'zh-CN': '提交人: {{value}}',
    en: 'Submitted by: {{value}}',
  },
  'pattern.orderId': {
    'zh-CN': '订单号: {{id}}',
    en: 'Order ID: {{id}}',
  },
  'pattern.formCount': {
    'zh-CN': '共 {{count}} 个表单',
    en: '{{count}} forms total',
  },
  'pattern.userCount': {
    'zh-CN': '共 {{count}} 个用户',
    en: '{{count}} users total',
  },
  'pattern.orderCount': {
    'zh-CN': '共 {{count}} 个订单',
    en: '{{count}} orders total',
  },
  'pattern.pageIndicator': {
    'zh-CN': '第 {{current}} / {{total}} 页',
    en: 'Page {{current}} of {{total}}',
  },
  'pattern.formTypeRequest': {
    'zh-CN': '{{type}}申请',
    en: '{{type}} Request',
  },
  'pattern.userToggleConfirm': {
    'zh-CN': '确定要{{action}}用户 {{email}} 吗？',
    en: 'Are you sure you want to {{action}} user {{email}}?',
  },
  'pattern.userToggleSuccess': {
    'zh-CN': '用户{{action}}成功',
    en: 'User {{action}} successful',
  },
  'pattern.userToggleFailure': {
    'zh-CN': '用户{{action}}失败',
    en: 'User {{action}} failed',
  },
  'pattern.removeRoleConfirm': {
    'zh-CN': '确定要移除角色 "{{role}}" 吗？',
    en: 'Are you sure you want to remove role "{{role}}"?',
  },
  'pattern.deleteRoleConfirm': {
    'zh-CN': '确定要删除角色“{{role}}”吗？',
    en: 'Are you sure you want to delete role "{{role}}"?',
  },
  'pattern.airportRoute': {
    'zh-CN': '机场接送 - {{pickup}} → {{dropoff}}',
    en: 'Airport Transfer - {{pickup}} → {{dropoff}}',
  },
  'pattern.rentalApplicationAddress': {
    'zh-CN': '租房申请 - {{address}}',
    en: 'Rental Application - {{address}}',
  },
  'pattern.fileInfo': {
    'zh-CN': '文件信息: {{value}}',
    en: 'File info: {{value}}',
  },
  'pattern.formParseFailed': {
    'zh-CN': '表单数据解析失败: {{error}}',
    en: 'Failed to parse form data: {{error}}',
  },
  'pattern.supportMailBody': {
    'zh-CN':
      '我在提交申请时遇到了问题，需要您的协助。\n\n问题详情：\n- 时间：{{time}}\n- 页面：{{page}}\n- 浏览器：{{browser}}\n\n请协助处理，谢谢！',
    en: 'I ran into an issue while submitting my application and need your help.\n\nDetails:\n- Time: {{time}}\n- Page: {{page}}\n- Browser: {{browser}}\n\nPlease assist. Thank you.',
  },
};

const publicPageMessages: Record<string, MessageDescriptor> = {
  'public.footer.description': {
    'zh-CN': '专业的珀斯房屋代看服务平台，致力于为海外租房者提供便捷、可靠的租房解决方案',
    en: 'A Perth-based rental assistance platform helping overseas renters with convenient and reliable support.',
  },
  'public.footer.wechatId': {
    'zh-CN': '微信号：Easy-Aussie',
    en: 'WeChat ID: Easy-Aussie',
  },
  'public.footer.disclaimer.positioningLead': {
    'zh-CN': 'EasyAussie 仅提供租客侧协助服务。',
    en: 'EasyAussie only provides renter-side assistance.',
  },
  'public.footer.disclaimer.positioningBody': {
    'zh-CN':
      '所有服务均为代表租客执行，旨在协助租房相关流程，包括房源代看、申请材料准备以及一般性的本地协助服务。',
    en: 'All services are carried out on behalf of renters to assist with the rental process, including inspections, application preparation, and general local support.',
  },
  'public.footer.disclaimer.natureBody': {
    'zh-CN':
      'EasyAussie 并非房地产中介、物业管理方、验房人员或任何持牌专业机构，亦不提供法律、财务或专业性质的房屋评估与建议。',
    en: 'EasyAussie is not a real estate agent, property manager, inspector, or licensed professional body, and does not provide legal, financial, or professional property advice.',
  },
  'public.footer.disclaimer.inspectionBody': {
    'zh-CN':
      '仅限于代替租客参加 open home 并进行现场情况记录，具体是否允许拍摄以中介现场要求为准。所提供的视频及照片仅作为客观记录，不构成任何形式的专业验房或评估意见。',
    en: 'This service is limited to attending open homes on behalf of renters and recording what is seen on site. Whether filming is allowed depends on the agent. Any videos or photos are objective records only and do not constitute professional inspection or assessment.',
  },
  'public.footer.disclaimer.applicationBody': {
    'zh-CN':
      '完全基于租客所提供的信息与材料。EasyAussie 不对租房申请结果或是否成功获批作出任何保证。',
    en: 'This service is based entirely on the information and materials provided by the renter. EasyAussie does not guarantee the result of any rental application.',
  },
  'public.footer.disclaimer.errandBody': {
    'zh-CN':
      '均为非专业、观察性协助，不能替代官方的 Property Condition Report、正式验房或第三方专业评估。',
    en: 'These services are non-professional observational assistance and cannot replace an official Property Condition Report, a formal inspection, or third-party professional assessment.',
  },
  'public.footer.disclaimer.reminderBody': {
    'zh-CN':
      '所有服务均在租客明确请求并授权的前提下提供。具体服务范围、可行性及费用将根据实际需求与所在地情况有所不同。',
    en: 'All services are provided only at the renter’s explicit request and authorization. Scope, feasibility, and pricing depend on the actual request and location.',
  },
  'public.home.title': {
    'zh-CN': 'Easy Aussie - 珀斯租房服务专家',
    en: 'Easy Aussie - Perth Rental Support Specialists',
  },
  'public.home.heroTitle': {
    'zh-CN': '珀斯租房服务专家',
    en: 'Perth Rental Support Specialists',
  },
  'public.home.heroSubtitle': {
    'zh-CN': '深耕本地市场 · 专业可靠服务',
    en: 'Deep local expertise · Professional and reliable service',
  },
  'public.home.coreServices': {
    'zh-CN': '核心服务',
    en: 'Core Services',
  },
  'public.home.coreServicesDesc': {
    'zh-CN': '专业团队为您提供全方位珀斯租房服务支持',
    en: 'A professional team supporting every part of your Perth rental journey',
  },
  'public.home.inspection': {
    'zh-CN': '房源代看',
    en: 'Property Viewing Assistance',
  },
  'public.home.inspectionItem1': {
    'zh-CN': '现场录制完整看房视频',
    en: 'Complete on-site viewing video recording',
  },
  'public.home.inspectionItem2': {
    'zh-CN': '房屋周边环境及交通',
    en: 'Surroundings and transport information',
  },
  'public.home.inspectionItem3': {
    'zh-CN': '房屋采光、隔音',
    en: 'Lighting and sound insulation checks',
  },
  'public.home.inspectionItem4': {
    'zh-CN': '与中介沟通并代为提问',
    en: 'Communicate with the agent and ask questions for you',
  },
  'public.home.applicationHelp': {
    'zh-CN': '申请协助',
    en: 'Application Assistance',
  },
  'public.home.applicationItem1': {
    'zh-CN': '提供申请与租房申请信信息清单',
    en: 'Provide an application and cover letter checklist',
  },
  'public.home.applicationItem2': {
    'zh-CN': '协助检查并整理租客申请材料',
    en: 'Review and organize rental application documents',
  },
  'public.home.applicationItem3': {
    'zh-CN': '撰写租房申请信',
    en: 'Write your rental cover letter',
  },
  'public.home.applicationItem4': {
    'zh-CN': '填写并递交完整租房申请',
    en: 'Complete and submit the rental application',
  },
  'public.home.errands': {
    'zh-CN': '跑腿服务',
    en: 'Errand Assistance',
  },
  'public.home.errandItem1': {
    'zh-CN': '钥匙交接代办',
    en: 'Key handover assistance',
  },
  'public.home.errandItem2': {
    'zh-CN': '入住房屋检查',
    en: 'Move-in property checks',
  },
  'public.home.errandItem3': {
    'zh-CN': '物品取送协助',
    en: 'Pickup and delivery assistance',
  },
  'public.home.whyUs': {
    'zh-CN': '为什么选择我们',
    en: 'Why Choose Us',
  },
  'public.home.whyUsDesc': {
    'zh-CN': '专业经验与可靠服务的完美结合',
    en: 'A practical mix of experience and dependable service',
  },
  'public.home.experience': {
    'zh-CN': '专业经验',
    en: 'Experience',
  },
  'public.home.experienceItem1': {
    'zh-CN': '已在珀斯提供代看服务 {{localYears}} 年以上',
    en: 'Providing viewing assistance in Perth for over {{localYears}} years',
  },
  'public.home.experienceItem2': {
    'zh-CN': '累计完成 {{viewingCount}}+ 套房源代看，熟悉本地租房市场',
    en: '{{viewingCount}}+ property viewings completed with strong knowledge of the local market',
  },
  'public.home.experienceItem3': {
    'zh-CN': '基于现场情况，提供清晰、客观的看房反馈',
    en: 'Clear and objective feedback based on what is actually seen on site',
  },
  'public.home.experienceItem4': {
    'zh-CN': '熟悉中介看房流程，能有效沟通并获取关键信息',
    en: 'Familiar with agent viewing workflows and effective at getting key information',
  },
  'public.home.reliable': {
    'zh-CN': '高度可靠',
    en: 'Reliable Delivery',
  },
  'public.home.reliableItem1': {
    'zh-CN': '按预约流程到场，与中介配合完成看房',
    en: 'Attend as scheduled and complete the viewing process with the agent',
  },
  'public.home.reliableItem2': {
    'zh-CN': '实拍房屋及周边环境，信息真实可核查',
    en: 'Record the property and surroundings on site so the information stays verifiable',
  },
  'public.home.reliableItem3': {
    'zh-CN': '租客复购与口碑推荐稳定',
    en: 'Consistent repeat business and referrals from renters',
  },
  'public.home.reliableItem4': {
    'zh-CN': '已协助 {{successfulRentalCount}}+ 位租客成功租房，服务 {{servedRenterCount}}+ 位租客',
    en: 'Helped {{successfulRentalCount}}+ renters secure homes and served {{servedRenterCount}}+ renters in total',
  },
  'public.home.readyTitle': {
    'zh-CN': '准备开始您的珀斯租房之旅？',
    en: 'Ready to start your Perth rental journey?',
  },
  'public.home.metaDesc': {
    'zh-CN': '深耕珀斯租房市场，专业房源代看、申请协助、租房跑腿一站式服务',
    en: 'One-stop Perth rental support including viewings, application help, and local errand services.',
  },
};

Object.assign(messageCatalog, patternMessages, publicPageMessages);

const accountAndServiceMessages: Record<string, MessageDescriptor> = {
  'common.selectPlease': { 'zh-CN': '请选择', en: 'Please select' },
  'common.enable': { 'zh-CN': '启用', en: 'Enable' },
  'common.disable': { 'zh-CN': '禁用', en: 'Disable' },
  'common.search': { 'zh-CN': '搜索', en: 'Search' },
  'common.clearFilters': { 'zh-CN': '清空筛选', en: 'Clear Filters' },
  'common.reload': { 'zh-CN': '重新加载', en: 'Reload' },
  'common.view': { 'zh-CN': '查看', en: 'View' },
  'common.edit': { 'zh-CN': '编辑', en: 'Edit' },
  'common.delete': { 'zh-CN': '删除', en: 'Delete' },
  'common.approve': { 'zh-CN': '通过', en: 'Approve' },
  'common.reject': { 'zh-CN': '拒绝', en: 'Reject' },
  'common.download': { 'zh-CN': '下载', en: 'Download' },
  'common.exportData': { 'zh-CN': '导出数据', en: 'Export Data' },
  'common.createForm': { 'zh-CN': '新建表单', en: 'Create Form' },
  'common.loadingFailedRetry': {
    'zh-CN': '加载失败，请重试',
    en: 'Loading failed. Please try again.',
  },
  'common.noData': { 'zh-CN': '暂无角色数据', en: 'No role data yet' },
  'common.optional': { 'zh-CN': '可选', en: 'Optional' },
  'common.saveFailed': { 'zh-CN': '保存失败', en: 'Save failed' },
  'common.deleteFailed': { 'zh-CN': '删除失败', en: 'Delete failed' },
  'common.requestFailedLater': {
    'zh-CN': '提交失败，请稍后重试',
    en: 'Submission failed. Please try again later.',
  },
  'common.requestFailedSupport': {
    'zh-CN': '提交失败，请稍后重试或联系客服。',
    en: 'Submission failed. Please try again later or contact support.',
  },
  'common.requestFailedSupportShort': {
    'zh-CN': '提交失败，请重试或联系客服',
    en: 'Submission failed. Please try again or contact support.',
  },
  'common.submitSuccess': { 'zh-CN': '提交成功', en: 'Submitted successfully' },
  'common.submitSuccessContact': {
    'zh-CN': '提交成功！我们会尽快与您联系。',
    en: 'Submitted successfully. We will contact you soon.',
  },
  'common.pleaseLoginFirst': {
    'zh-CN': '请先登录后再提交预约',
    en: 'Please sign in before submitting your booking.',
  },
  'common.goLogin': { 'zh-CN': '去登录', en: 'Go to Sign In' },
  'common.relogin': { 'zh-CN': '重新登录', en: 'Sign In Again' },
  'common.authExpired': {
    'zh-CN': '登录已过期，请重新登录',
    en: 'Your session has expired. Please sign in again.',
  },
  'auth.loginTitle': { 'zh-CN': '登录 - Easy Aussie', en: 'Sign In - Easy Aussie' },
  'auth.loginHeading': { 'zh-CN': '登录 Easy Aussie', en: 'Sign In to Easy Aussie' },
  'auth.registerTitle': { 'zh-CN': '注册 - Easy Aussie', en: 'Sign Up - Easy Aussie' },
  'auth.registerHeading': { 'zh-CN': '注册 Easy Aussie', en: 'Create an Easy Aussie Account' },
  'auth.email': { 'zh-CN': '邮箱地址', en: 'Email Address' },
  'auth.password': { 'zh-CN': '密码', en: 'Password' },
  'auth.confirmPassword': { 'zh-CN': '确认密码', en: 'Confirm Password' },
  'auth.captcha': { 'zh-CN': '验证码', en: 'Captcha' },
  'auth.refreshCaptchaHint': {
    'zh-CN': '点击验证码图片刷新',
    en: 'Click the captcha image to refresh',
  },
  'auth.noAccount': { 'zh-CN': '还没有账户？', en: "Don't have an account?" },
  'auth.hasAccount': { 'zh-CN': '已有账户？', en: 'Already have an account?' },
  'auth.loginNow': { 'zh-CN': '立即登录', en: 'Sign In Now' },
  'auth.registerNow': { 'zh-CN': '立即注册', en: 'Create Account' },
  'auth.terms': { 'zh-CN': '服务条款', en: 'Terms of Service' },
  'auth.privacy': { 'zh-CN': '隐私政策', en: 'Privacy Policy' },
  'auth.loginDesc': {
    'zh-CN': '登录 Easy Aussie 管理中心',
    en: 'Sign in to Easy Aussie',
  },
  'auth.registerDesc': {
    'zh-CN': '注册 Easy Aussie 账户',
    en: 'Create your Easy Aussie account',
  },
  'auth.fillLogin': {
    'zh-CN': '请填写完整的登录信息',
    en: 'Please complete all sign-in fields.',
  },
  'auth.fillRegister': {
    'zh-CN': '请填写完整的注册信息',
    en: 'Please complete all registration fields.',
  },
  'auth.invalidEmail': {
    'zh-CN': '请输入有效的邮箱地址',
    en: 'Please enter a valid email address.',
  },
  'auth.passwordMismatch': {
    'zh-CN': '两次输入的密码不一致',
    en: 'The two passwords do not match.',
  },
  'auth.passwordMin6': {
    'zh-CN': '密码长度至少为6位',
    en: 'Password must be at least 6 characters.',
  },
  'auth.signingIn': { 'zh-CN': '登录中...', en: 'Signing in...' },
  'auth.signingUp': { 'zh-CN': '注册中...', en: 'Creating account...' },
  'auth.validatingLogin': {
    'zh-CN': '正在验证登录信息...',
    en: 'Verifying your sign-in details...',
  },
  'auth.creatingAccount': {
    'zh-CN': '正在创建账户...',
    en: 'Creating your account...',
  },
  'auth.loginSuccessRedirect': {
    'zh-CN': '登录成功！正在跳转...',
    en: 'Sign-in successful. Redirecting...',
  },
  'auth.registerSuccessRedirect': {
    'zh-CN': '注册成功！正在跳转到登录页面...',
    en: 'Registration successful. Redirecting to sign-in...',
  },
  'auth.loginFailed': {
    'zh-CN': '登录失败，请检查用户名和密码',
    en: 'Sign-in failed. Please check your email and password.',
  },
  'auth.registerFailed': {
    'zh-CN': '注册失败，请重试',
    en: 'Registration failed. Please try again.',
  },
  'auth.registerFailedShort': { 'zh-CN': '注册失败', en: 'Registration failed' },
  'auth.captchaRetry': {
    'zh-CN': '验证码加载失败，点击重试',
    en: 'Captcha failed to load. Click to retry.',
  },
  'auth.enter4Captcha': {
    'zh-CN': '请输入4位验证码',
    en: 'Please enter the 4-digit captcha.',
  },
  'auth.passwordPlaceholder': {
    'zh-CN': '请输入密码',
    en: 'Enter your password',
  },
  'auth.passwordPlaceholderMin': {
    'zh-CN': '请输入密码（至少6位）',
    en: 'Enter a password (at least 6 characters)',
  },
  'auth.confirmPasswordPlaceholder': {
    'zh-CN': '请再次输入密码',
    en: 'Enter your password again',
  },
  'auth.unauthorizedTitle': {
    'zh-CN': '权限不足 - Easy Aussie',
    en: 'Access Denied - Easy Aussie',
  },
  'auth.unauthorizedHeading': { 'zh-CN': '权限不足', en: 'Access Denied' },
  'auth.unauthorizedDesc': {
    'zh-CN': '当前账号暂无权限访问此页面',
    en: 'Your current account does not have permission to access this page.',
  },
  'auth.contactAdmin': {
    'zh-CN': '如需协助，请联系管理员',
    en: 'If you need help, please contact the administrator.',
  },
  'auth.backHome': { 'zh-CN': '返回主页', en: 'Back to Home' },
};

Object.assign(messageCatalog, accountAndServiceMessages);

const serviceGuideAndDashboardMessages: Record<string, MessageDescriptor> = {
  'service.selectionTitle': {
    'zh-CN': '选择服务 - Easy Aussie',
    en: 'Choose a Service - Easy Aussie',
  },
  'service.selectionHeading': { 'zh-CN': '选择您需要的服务', en: 'Choose the Service You Need' },
  'service.selectionDesc': {
    'zh-CN': '专业团队为您提供全方位的珀斯租房服务支持',
    en: 'Professional support across every step of your Perth rental journey',
  },
  'service.bookInspection': { 'zh-CN': '预约看房', en: 'Book Appointment' },
  'service.bookNow': { 'zh-CN': '立即预约', en: 'Book Now' },
  'service.bookInspectionDesc': {
    'zh-CN': '专业代看房服务，实拍房屋与周边情况，提供真实的现场信息',
    en: 'Professional viewing assistance with on-site footage of the property and surroundings.',
  },
  'service.coverletterDesc': {
    'zh-CN': '结合租客背景与中介、房东常见关注点，撰写个性化、清晰和规范的租房介绍信',
    en: 'Personalized rental cover letters based on renter background and common landlord and agent concerns.',
  },
  'service.applicationDesc': {
    'zh-CN': '根据个人情况协助整理并填写租房申请材料，减少遗漏与出错，让流程更省心、高效',
    en: 'Help organize and complete rental application materials with fewer omissions and mistakes.',
  },
  'service.airportDesc': {
    'zh-CN': '提供安全、准时的机场接机服务，协助顺利抵达并开启珀斯生活',
    en: 'Safe and punctual airport pickup to help you settle into Perth smoothly.',
  },
  'service.needAdvice': { 'zh-CN': '需要专业建议？', en: 'Need Professional Advice?' },
  'service.needAdviceDesc': {
    'zh-CN': '不确定选择哪项服务？联系我们的专业顾问，获取个性化建议',
    en: 'Not sure which service fits best? Contact us for tailored advice.',
  },
  'service.selectionMeta': {
    'zh-CN': '选择您需要的专业服务，我们为您提供全方位的澳洲生活支持',
    en: 'Choose the right professional service and get practical support for life in Australia.',
  },
  'service.inspectionTitle': {
    'zh-CN': '预约看房 - Easy Aussie',
    en: 'Book Appointment - Easy Aussie',
  },
  'service.inspectionMeta': {
    'zh-CN': '预约专业代看房服务，远程了解真实房屋情况',
    en: 'Book professional viewing assistance and understand the property remotely.',
  },
  'service.userNoticeHint': {
    'zh-CN': '提示：提交预约需要先登录账户',
    en: 'Reminder: you need to sign in before submitting a booking.',
  },
  'service.signInNow': { 'zh-CN': '现在登录', en: 'Sign In Now' },
  'service.submittingInspection': {
    'zh-CN': '正在提交预约...',
    en: 'Submitting your booking...',
  },
  'service.inspectionSuccess': {
    'zh-CN': '预约提交成功！我们会尽快与您联系。',
    en: 'Viewing request submitted successfully. We will contact you soon.',
  },
  'service.noticeTitle': { 'zh-CN': '服务须知', en: 'Service Notice' },
  'service.noticeDesc': {
    'zh-CN': '请仔细阅读以下条款，确保您了解服务详情',
    en: 'Please read the following terms carefully to understand the service.',
  },
  'service.importantNotes': { 'zh-CN': '重要注意事项', en: 'Important Notes' },
  'service.paymentPolicy': { 'zh-CN': '付费政策', en: 'Payment Policy' },
  'service.paymentPolicyBody': {
    'zh-CN': '服务需预先付费，支持澳币（AUD）或人民币（RMB）支付。',
    en: 'Payment is required in advance and can be made in AUD or RMB.',
  },
  'service.cancellationPolicy': { 'zh-CN': '退改规定', en: 'Cancellation Policy' },
  'service.sameDayCancel': { 'zh-CN': '当天临时取消：', en: 'Same-day cancellation:' },
  'service.sameDayCancelBody': { 'zh-CN': '不予退款', en: 'No refund' },
  'service.notice13Days': { 'zh-CN': '提前1-3天通知：', en: '1-3 days notice:' },
  'service.notice13DaysBody': { 'zh-CN': '退还50%费用', en: '50% refund' },
  'service.notice3PlusDays': { 'zh-CN': '提前3天以上通知：', en: 'More than 3 days notice:' },
  'service.notice3PlusDaysBody': { 'zh-CN': '全额退款', en: 'Full refund' },
  'service.specialNote': {
    'zh-CN': '特殊说明：中介或房东取消看房时，同样按以上规定处理；若中介迟到,可等待10分钟。',
    en: 'Special note: if the agent or landlord cancels the viewing, the same policy applies; if the agent is late, please allow 10 minutes.',
  },
  'service.viewingNotice': { 'zh-CN': '看房须知', en: 'Viewing Notes' },
  'service.viewingDuration': { 'zh-CN': '看房时长：', en: 'Viewing duration:' },
  'service.viewingDurationBody': {
    'zh-CN': '一般为10-15分钟（由中介规定）',
    en: 'Usually 10-15 minutes, depending on the agent.',
  },
  'service.questionAdvice': { 'zh-CN': '提问建议：', en: 'Question advice:' },
  'service.questionAdviceBody': {
    'zh-CN': '请提前提供1-5个关键问题，我们会尽量向中介了解',
    en: 'Please provide 1-5 key questions in advance and we will try to ask the agent.',
  },
  'service.kindReminder': {
    'zh-CN': '温馨提示：由于中介接待租客较多（部分房源超过20组），请确保问题简洁明了。',
    en: 'Friendly reminder: agents may be hosting many groups, so please keep questions concise.',
  },
  'service.processTitle': { 'zh-CN': '代看房流程', en: 'Viewing Assistance Process' },
  'service.process1': {
    'zh-CN': '到达现场，拍摄房屋周边环境视频',
    en: 'Arrive on site and record the surrounding environment',
  },
  'service.process2': {
    'zh-CN': '与中介签到，提供预约信息',
    en: 'Check in with the agent using your booking details',
  },
  'service.process3': {
    'zh-CN': '进入房屋，拍摄视频/照片',
    en: 'Enter the property and take videos or photos',
  },
  'service.process4': {
    'zh-CN': '检查房屋采光、隔音、家具等',
    en: 'Check lighting, sound insulation, furniture, and general condition',
  },
  'service.process5': {
    'zh-CN': '向中介咨询您关心的问题',
    en: 'Ask the agent the questions you care about',
  },
  'service.basicNotice': {
    'zh-CN':
      '服务说明：本服务为基础代看，不提供专业验房报告。如需入住前房屋检查，属于不同服务类别。',
    en: 'Service note: this is a basic viewing assistance service and does not include a professional inspection report.',
  },
  'service.includesTitle': { 'zh-CN': '服务内容包含', en: 'What the Service Includes' },
  'service.includes1': {
    'zh-CN': '一镜到底高清视频（中介允许时）',
    en: 'Continuous walkthrough video when allowed by the agent',
  },
  'service.includes2': {
    'zh-CN': '房屋外部与周边环境展示',
    en: 'Exterior and surrounding environment footage',
  },
  'service.includes3': { 'zh-CN': '简单交通信息介绍', en: 'Basic transport information' },
  'service.includes4': {
    'zh-CN': '向中介咨询关键问题（最多5个）',
    en: 'Ask the agent key questions, up to 5',
  },
  'service.includes5': {
    'zh-CN': '检查采光、隔音、家具等基本情况',
    en: 'Basic checks of lighting, sound insulation, and furniture',
  },
  'service.includes6': { 'zh-CN': '详细照片和视频记录', en: 'Detailed photos and video records' },
  'service.confirmReadTerms': {
    'zh-CN': '请确认您已阅读并理解以上条款',
    en: 'Please confirm that you have read and understood the terms above',
  },
  'service.backToEdit': { 'zh-CN': '返回修改', en: 'Go Back and Edit' },
  'service.confirmSubmit': { 'zh-CN': '我已知晓，确认提交', en: 'I understand and want to submit' },
  'service.applicationTitle': {
    'zh-CN': '租房申请 - Easy Aussie',
    en: 'Rental Application - Easy Aussie',
  },
  'service.applicationMeta': {
    'zh-CN': '填写详细的租房申请信息，提高申请成功率',
    en: 'Complete a detailed rental application to improve your chances.',
  },
  'service.submittingApplication': {
    'zh-CN': '正在提交租房申请...',
    en: 'Submitting your rental application...',
  },
  'service.applicationSuccess': {
    'zh-CN': '申请提交成功！我们会尽快处理您的申请。',
    en: 'Application submitted successfully. We will review it as soon as possible.',
  },
  'service.coverletterTitle': {
    'zh-CN': '租房申请信信息填写 - Easy Aussie',
    en: 'Cover Letter Information - Easy Aussie',
  },
  'service.coverletterMeta': {
    'zh-CN': '提交租房申请信信息，我们将为您生成规范、专业的求租信',
    en: 'Submit your rental cover letter details and we will prepare a professional letter for you.',
  },
  'service.max3RentalRecords': {
    'zh-CN': '最多只能添加3条居住记录',
    en: 'You can add up to 3 rental history entries.',
  },
  'service.addedRentalRecord': { 'zh-CN': '已新增居住记录', en: 'Rental history added' },
  'service.deletedRentalRecord': { 'zh-CN': '已删除居住记录', en: 'Rental history removed' },
  'service.submittingCoverletter': {
    'zh-CN': '正在提交租房申请信信息...',
    en: 'Submitting your cover letter details...',
  },
  'service.coverletterSuccess': {
    'zh-CN': '提交成功！我们会尽快为您准备租房申请信。',
    en: 'Submitted successfully. We will prepare your cover letter soon.',
  },
  'service.airportTitle': {
    'zh-CN': '机场接机服务 - Easy Aussie',
    en: 'Airport Pickup - Easy Aussie',
  },
  'service.airportMeta': {
    'zh-CN': '预订专业的机场接机服务，安全舒适地到达目的地',
    en: 'Book professional airport pickup and arrive safely and comfortably.',
  },
  'service.submittingAirport': {
    'zh-CN': '正在提交接机预约...',
    en: 'Submitting your airport pickup request...',
  },
  'service.airportSuccess': {
    'zh-CN': '接机预约提交成功！我们会尽快与您联系。',
    en: 'Airport pickup request submitted successfully. We will contact you soon.',
  },
  'service.guideTitle': { 'zh-CN': '用户指南 - Easy Aussie', en: 'Guide - Easy Aussie' },
  'service.guideMeta': {
    'zh-CN': '租房流程、服务介绍与价格说明一页看懂',
    en: 'Understand the rental process, services, and pricing at a glance.',
  },
  'result.failTitle': { 'zh-CN': '提交失败 - Easy Aussie', en: 'Submission Failed - Easy Aussie' },
  'result.failHeading': { 'zh-CN': '提交失败', en: 'Submission Failed' },
  'result.successTitle': {
    'zh-CN': '提交成功 - Easy Aussie',
    en: 'Submission Successful - Easy Aussie',
  },
  'result.successHeading': { 'zh-CN': '提交成功', en: 'Submission Successful' },
  'result.confirmation': { 'zh-CN': '提交确认', en: 'Submission Confirmed' },
  'result.confirmationBody': {
    'zh-CN': '您的信息已成功提交',
    en: 'Your information has been submitted successfully.',
  },
  'result.processing': { 'zh-CN': '资料处理中', en: 'Processing' },
  'result.processingBody': {
    'zh-CN': '我们将尽快处理您的提交内容',
    en: 'We will process your submission as soon as possible.',
  },
  'result.notify': { 'zh-CN': '结果通知', en: 'Notification' },
  'result.notifyBody': {
    'zh-CN': '处理完成后我们会及时联系您',
    en: 'We will contact you once processing is complete.',
  },
  'result.techDetails': { 'zh-CN': '技术详情：', en: 'Technical details:' },
  'result.supportSubject': {
    'zh-CN': '提交失败求助 - Easy Aussie',
    en: 'Help Needed for Failed Submission - Easy Aussie',
  },
  'admin.dashboard.quickActions': { 'zh-CN': '快速操作', en: 'Quick Actions' },
  'admin.dashboard.recentActivities': { 'zh-CN': '最近活动', en: 'Recent Activity' },
  'admin.dashboard.addUser': { 'zh-CN': '添加用户', en: 'Add User' },
  'admin.dashboard.newForm': { 'zh-CN': '新建表单', en: 'New Form' },
  'admin.dashboard.settings': { 'zh-CN': '系统设置', en: 'Settings' },
  'admin.dashboard.analytics': { 'zh-CN': '数据分析', en: 'Analytics' },
  'admin.dashboard.monitoring': { 'zh-CN': '系统监控', en: 'Monitoring' },
  'admin.dashboard.export': { 'zh-CN': '数据导出', en: 'Export' },
  'admin.dashboard.newUser': { 'zh-CN': '新用户注册', en: 'New user registered' },
  'admin.dashboard.formSubmitted': { 'zh-CN': '表单提交', en: 'Form submitted' },
  'admin.dashboard.systemUpdate': { 'zh-CN': '系统更新', en: 'System updated' },
  'admin.dashboard.fiveMinutesAgo': { 'zh-CN': '5分钟前', en: '5 minutes ago' },
  'admin.dashboard.tenMinutesAgo': { 'zh-CN': '10分钟前', en: '10 minutes ago' },
  'admin.dashboard.thirtyMinutesAgo': { 'zh-CN': '30分钟前', en: '30 minutes ago' },
  'admin.dashboard.totalUsers': { 'zh-CN': '总用户数', en: 'Total Users' },
  'admin.dashboard.totalForms': { 'zh-CN': '总表单数', en: 'Total Forms' },
  'admin.dashboard.pendingTasks': { 'zh-CN': '待处理', en: 'Pending' },
  'admin.dashboard.monthGrowth': { 'zh-CN': '本月增长', en: 'Monthly Growth' },
};

Object.assign(messageCatalog, serviceGuideAndDashboardMessages);

const guideAdminUserMessages: Record<string, MessageDescriptor> = {
  'guide.platformIntro': {
    'zh-CN':
      '在澳洲租房，常见的找房平台与正式申请平台并不完全一致，提前了解各平台的使用方式，可以有效减少重复操作。',
    en: 'In Australia, search platforms and formal application platforms are not always the same. Understanding how each one works helps reduce duplicated effort.',
  },
  'guide.commonPlatforms': { 'zh-CN': '常用租房平台', en: 'Common Rental Platforms' },
  'guide.realestateDesc': {
    'zh-CN': '房源最全，信息更新快，适合筛选房源与预约看房',
    en: 'The largest listing platform with fast updates, ideal for searching listings and booking inspections.',
  },
  'guide.domainDesc': {
    'zh-CN': '与 Realestate 类似，看房状态展示较为清晰',
    en: 'Similar to Realestate, with clear inspection status information.',
  },
  'guide.twoApplyDesc': {
    'zh-CN': '主要用于正式提交租房申请',
    en: 'Mainly used for formal rental applications.',
  },
  'guide.platformAdvice': { 'zh-CN': '平台使用建议', en: 'Platform Advice' },
  'guide.viewStage': {
    'zh-CN': '看房阶段：优先使用 Realestate / Domain',
    en: 'Inspection stage: prioritize Realestate / Domain',
  },
  'guide.applyStage': {
    'zh-CN': '申请阶段：大多数中介会通过 2Apply 处理申请',
    en: 'Application stage: most agents process applications through 2Apply',
  },
  'guide.agentSites': {
    'zh-CN': '部分中介有独立官网，或要求直接在 Realestate 上提交申请（有时需要输入申请 Code）',
    en: 'Some agencies use their own websites or ask applicants to apply directly on Realestate, sometimes with an application code.',
  },
  'guide.summary': { 'zh-CN': '总结', en: 'Summary' },
  'guide.summaryBody': {
    'zh-CN': 'Realestate 更适合“选房 + 看房”，2Apply 更偏向“提交申请”。',
    en: 'Realestate is better for searching and inspecting, while 2Apply is more focused on the application step.',
  },
  'guide.improveInspection': { 'zh-CN': '提高看房成功率', en: 'Improve Inspection Success' },
  'guide.improveInspectionBody': {
    'zh-CN': '筛选房源时，建议优先关注是否已公布看房时间。',
    en: 'When filtering listings, prioritize properties with published inspection times.',
  },
  'guide.keyFilters': { 'zh-CN': '筛选重点', en: 'Key Filters' },
  'guide.keyFilter1': {
    'zh-CN': '是否有明确的 Inspection 时间',
    en: 'Whether an inspection time is clearly listed',
  },
  'guide.keyFilter2': {
    'zh-CN': '租金范围、房型、区域是否符合自身需求',
    en: 'Whether rent, property type, and area match your needs',
  },
  'guide.keyFilter3': {
    'zh-CN': '入住时间是否合适（参考 Available Date）',
    en: 'Whether the move-in timing is suitable (check the Available Date)',
  },
  'guide.importantTip': { 'zh-CN': '重要提示', en: 'Important Tip' },
  'guide.importantTip1': {
    'zh-CN': '未公布看房时间的房源，通常需要等待中介回复',
    en: 'Listings without an inspection time usually require waiting for the agent to reply.',
  },
  'guide.importantTip2': {
    'zh-CN': '等待后可能出现：提供新的看房时间 / 看房名额已满暂无安排',
    en: 'After waiting, the agent may either provide a new time or advise that inspection spots are already full.',
  },
  'guide.recommendedAction': { 'zh-CN': '建议做法', en: 'Recommended Approach' },
  'guide.recommendedAction1': {
    'zh-CN': '着急入住时，可同时选择多套房源预约看房',
    en: 'If you need to move in soon, book inspections for multiple properties at the same time.',
  },
  'guide.recommendedAction2': {
    'zh-CN': '优先选择已开放看房时间的房子，提高整体效率',
    en: 'Prioritize properties with open inspection times to improve overall efficiency.',
  },
  'guide.afterViewing': {
    'zh-CN': '看房过程中或结束后，符合条件的申请人通常会收到中介发送的申请链接。',
    en: 'During or after an inspection, eligible applicants usually receive an application link from the agent.',
  },
  'guide.applicationMethods': { 'zh-CN': '常见申请方式', en: 'Common Application Methods' },
  'guide.applicationMethod1': {
    'zh-CN': '大部分中介通过邮箱发送 2Apply 申请链接',
    en: 'Most agents send a 2Apply link by email',
  },
  'guide.applicationMethod2': {
    'zh-CN': '部分中介要求直接在 Realestate / 2Book 上提交申请',
    en: 'Some agents require applications directly through Realestate / 2Book',
  },
  'guide.applicationMethod3': {
    'zh-CN': '少数中介仍使用纸质表格或自有系统',
    en: 'A small number of agents still use paper forms or their own systems',
  },
  'guide.applicationIncludes': { 'zh-CN': '申请内容通常包括', en: 'Applications Usually Include' },
  'guide.applicationIncludes1': {
    'zh-CN': '个人信息与联系方式',
    en: 'Personal details and contact information',
  },
  'guide.applicationIncludes2': { 'zh-CN': '学习 / 工作情况', en: 'Study / work details' },
  'guide.applicationIncludes3': {
    'zh-CN': '租房履历与推荐人',
    en: 'Rental history and references',
  },
  'guide.applicationIncludes4': {
    'zh-CN': '租房申请信（非常重要）',
    en: 'Cover Letter (very important)',
  },
  'guide.keyReminder': { 'zh-CN': '关键提醒', en: 'Key Reminder' },
  'guide.keyReminder1': {
    'zh-CN': 'Perth 多数房源：不看房不建议直接申请',
    en: 'For most Perth rentals, applying without inspecting is not recommended',
  },
  'guide.keyReminder2': {
    'zh-CN': '所有信息需真实、完整，并填写在正确位置',
    en: 'All information should be truthful, complete, and placed correctly',
  },
  'guide.keyReminder3': {
    'zh-CN': '信息混乱或填写错误，申请可能会被直接拒绝',
    en: 'Messy or incorrect information may lead to direct rejection',
  },
  'guide.processTitle': { 'zh-CN': '租房流程', en: 'Rental Process' },
  'guide.processDesc': {
    'zh-CN': '从找房到入住的标准步骤，方便快速了解全流程',
    en: 'Standard steps from searching to moving in, for a quick overview of the full process',
  },
  'guide.step1': { 'zh-CN': 'STEP 1：租房前期准备', en: 'STEP 1: Prepare Before Renting' },
  'guide.step2': { 'zh-CN': 'STEP 2：房源信息筛选', en: 'STEP 2: Filter Listings' },
  'guide.step3': { 'zh-CN': 'STEP 3：预约现场看房', en: 'STEP 3: Book an Inspection' },
  'guide.step4': { 'zh-CN': 'STEP 4：提交租赁申请', en: 'STEP 4: Submit an Application' },
  'guide.step5': { 'zh-CN': 'STEP 5：中介审核确认', en: 'STEP 5: Agent Review and Confirmation' },
  'guide.step6': { 'zh-CN': 'STEP 6：签署合同入住', en: 'STEP 6: Sign the Lease and Move In' },
  'guide.faq': { 'zh-CN': '常见问题', en: 'FAQ' },
  'guide.readyTitle': { 'zh-CN': '准备开始租房流程？', en: 'Ready to start the rental process?' },
  'guide.readyDesc': {
    'zh-CN': '联系我们获取更详细的方案与报价',
    en: 'Contact us for a more detailed plan and quote',
  },
  'admin.forms.title': { 'zh-CN': '表单管理', en: 'Form Management' },
  'admin.forms.subtitle': {
    'zh-CN': '管理所有用户提交的表单',
    en: 'Manage all submitted user forms',
  },
  'admin.forms.list': { 'zh-CN': '表单列表', en: 'Form List' },
  'admin.users.title': { 'zh-CN': '用户管理', en: 'User Management' },
  'admin.users.subtitle': { 'zh-CN': '管理系统用户和权限', en: 'Manage users and permissions' },
  'admin.users.filters': { 'zh-CN': '筛选条件', en: 'Filters' },
  'admin.users.list': { 'zh-CN': '用户列表', en: 'User List' },
  'admin.users.notFound': { 'zh-CN': '用户不存在', en: 'User not found' },
  'admin.users.deleteUnavailable': {
    'zh-CN': '删除用户功能暂未开放',
    en: 'Delete user is not available yet',
  },
  'admin.users.addInProgress': {
    'zh-CN': '添加用户功能正在开发中',
    en: 'Add user is still under development',
  },
  'admin.roles.title': { 'zh-CN': '角色管理', en: 'Role Management' },
  'admin.roles.subtitle': {
    'zh-CN': '管理系统角色与访问权限',
    en: 'Manage system roles and access permissions',
  },
  'admin.roles.list': { 'zh-CN': '角色列表', en: 'Role List' },
  'admin.roles.code': { 'zh-CN': '代码', en: 'Code' },
  'admin.roles.name': { 'zh-CN': '名称', en: 'Name' },
  'admin.roles.description': { 'zh-CN': '描述', en: 'Description' },
  'admin.roles.color': { 'zh-CN': '颜色', en: 'Color' },
  'admin.roles.icon': { 'zh-CN': '图标', en: 'Icon' },
  'admin.roles.enabled': { 'zh-CN': '启用', en: 'Enabled' },
  'admin.roles.disabled': { 'zh-CN': '停用', en: 'Disabled' },
  'admin.roles.create': { 'zh-CN': '创建角色', en: 'Create Role' },
  'admin.roles.edit': { 'zh-CN': '编辑角色', en: 'Edit Role' },
  'admin.roles.fillRequired': {
    'zh-CN': '请填写角色代码和显示名称',
    en: 'Please fill in the role code and display name.',
  },
  'admin.roles.saved': { 'zh-CN': '角色已保存', en: 'Role saved' },
  'admin.roles.deleted': { 'zh-CN': '角色已删除', en: 'Role deleted' },
  'user.orders.total': { 'zh-CN': '总订单', en: 'Total Orders' },
  'user.orders.none': { 'zh-CN': '暂无订单', en: 'No Orders Yet' },
  'user.orders.noneDesc': {
    'zh-CN': '您还没有创建任何订单',
    en: 'You have not created any orders yet.',
  },
  'user.orders.notFound': { 'zh-CN': '未找到订单', en: 'No Orders Found' },
  'user.orders.adjustFilters': { 'zh-CN': '请尝试调整筛选条件', en: 'Try adjusting your filters.' },
  'user.orders.detailUnavailable': {
    'zh-CN': '无法获取订单详情',
    en: 'Unable to get order details',
  },
  'user.orders.detailFailed': { 'zh-CN': '获取订单详情失败', en: 'Failed to get order details' },
  'user.orders.listFailed': { 'zh-CN': '加载订单列表失败', en: 'Failed to load order list' },
  'user.profile.title': { 'zh-CN': '个人中心 - Easy Aussie', en: 'Profile - Easy Aussie' },
  'user.profile.meta': {
    'zh-CN': '管理您的账号信息和订单',
    en: 'Manage your account details and orders',
  },
  'user.profile.overview': { 'zh-CN': '账户概览', en: 'Account Overview' },
  'user.profile.overviewDesc': {
    'zh-CN': '您的订单统计概览',
    en: 'A summary of your order statistics',
  },
  'user.profile.accountInfo': { 'zh-CN': '账户信息', en: 'Account Information' },
  'user.profile.accountInfoDesc': {
    'zh-CN': '更新您的个人信息',
    en: 'Update your personal information',
  },
  'user.profile.security': { 'zh-CN': '安全设置', en: 'Security Settings' },
  'user.profile.securityDesc': { 'zh-CN': '管理您的账户安全', en: 'Manage your account security' },
  'user.profile.refreshSuccess': {
    'zh-CN': '用户信息和统计数据已刷新',
    en: 'Profile and statistics have been refreshed.',
  },
  'user.profile.refreshFailed': {
    'zh-CN': '刷新失败，请重试',
    en: 'Refresh failed. Please try again.',
  },
  'user.profile.enterName': { 'zh-CN': '请输入您的姓名', en: 'Please enter your name.' },
  'user.profile.saved': { 'zh-CN': '档案信息已成功更新', en: 'Profile updated successfully.' },
  'user.profile.saveFailed': { 'zh-CN': '保存失败，请重试', en: 'Save failed. Please try again.' },
  'user.profile.passwordFields': {
    'zh-CN': '请填写所有密码字段',
    en: 'Please fill in all password fields.',
  },
  'user.profile.passwordMismatch': {
    'zh-CN': '新密码和确认密码不匹配',
    en: 'New password and confirmation do not match.',
  },
  'user.profile.passwordMin': {
    'zh-CN': '新密码长度至少为6位',
    en: 'New password must be at least 6 characters.',
  },
  'user.profile.passwordSaved': { 'zh-CN': '密码修改成功', en: 'Password updated successfully.' },
  'user.profile.passwordFailed': { 'zh-CN': '密码修改失败', en: 'Password update failed.' },
  'user.profile.passwordRetry': {
    'zh-CN': '密码修改失败，请重试',
    en: 'Password update failed. Please try again.',
  },
  'user.profile.deleteWarn': {
    'zh-CN': '警告：此操作将永久删除您的账户和所有相关数据，此操作无法撤销。确定要继续吗？',
    en: 'Warning: this will permanently delete your account and all related data and cannot be undone. Continue?',
  },
  'user.profile.contactSupport': {
    'zh-CN': '账户注销功能需要联系客服处理',
    en: 'Account deletion currently requires contacting support.',
  },
  'admin.forms.confirmApprove': { 'zh-CN': '确定要通过这个表单吗？', en: 'Approve this form?' },
  'admin.forms.confirmReject': { 'zh-CN': '确定要拒绝这个表单吗？', en: 'Reject this form?' },
  'admin.forms.confirmDelete': { 'zh-CN': '确定要删除这个表单吗？', en: 'Delete this form?' },
  'common.notConfiguredSubmit': {
    'zh-CN': '未配置提交处理方式',
    en: 'No submit handler configured',
  },
  'common.allStatuses': { 'zh-CN': '所有状态', en: 'All Statuses' },
  'common.allTypes': { 'zh-CN': '所有类型', en: 'All Types' },
  'common.allRoles': { 'zh-CN': '全部角色', en: 'All Roles' },
  'common.allStatusesAlt': { 'zh-CN': '全部状态', en: 'All Statuses' },
  'common.processing': { 'zh-CN': '处理中', en: 'Processing' },
  'common.remark': { 'zh-CN': '备注', en: 'Notes' },
  'common.operation': { 'zh-CN': '操作', en: 'Actions' },
  'common.type': { 'zh-CN': '类型', en: 'Type' },
  'common.status': { 'zh-CN': '状态', en: 'Status' },
  'common.contactInfo': { 'zh-CN': '联系方式', en: 'Contact' },
  'common.basicInfo': { 'zh-CN': '基本信息', en: 'Basic Information' },
  'common.name': { 'zh-CN': '姓名', en: 'Name' },
  'common.phone': { 'zh-CN': '电话', en: 'Phone' },
  'common.wechatName': { 'zh-CN': '微信昵称', en: 'Contact Name' },
  'common.registerTime': { 'zh-CN': '注册时间', en: 'Registered At' },
  'common.lastLogin': { 'zh-CN': '最后登录', en: 'Last Login' },
  'common.neverLoggedIn': { 'zh-CN': '从未登录', en: 'Never logged in' },
  'common.notSet': { 'zh-CN': '未设置', en: 'Not set' },
  'common.notFilled': { 'zh-CN': '未填写', en: 'Not provided' },
};

Object.assign(messageCatalog, guideAdminUserMessages);

const formFieldMessages: Record<string, MessageDescriptor> = {
  'field.address': { 'zh-CN': '地址', en: 'Address' },
  'field.rent': { 'zh-CN': '租金', en: 'Rent' },
  'field.rentalType': { 'zh-CN': '租房类型', en: 'Rental Type' },
  'field.ownerOccupied': { 'zh-CN': '自有住房', en: 'Owner Occupied' },
  'field.studentApartment': {
    'zh-CN': '学生公寓（有合同）',
    en: 'Student Apartment (with contract)',
  },
  'field.privateLandlord': {
    'zh-CN': '房东直租（有合同）',
    en: 'Private Landlord (with contract)',
  },
  'field.agentRental': { 'zh-CN': '中介租房（有合同）', en: 'Agency Rental (with contract)' },
  'field.otherNoContract': { 'zh-CN': '其他（无合同）', en: 'Other (no contract)' },
  'field.note': { 'zh-CN': '备注', en: 'Notes' },
  'field.startDate': { 'zh-CN': '起始日期', en: 'Start Date' },
  'field.endDate': { 'zh-CN': '结束日期', en: 'End Date' },
  'field.contactName': { 'zh-CN': '联系人姓名', en: 'Contact Name' },
  'field.contactRole': { 'zh-CN': '联系人身份', en: 'Contact Role' },
  'field.contactPhone': { 'zh-CN': '联系人电话', en: 'Contact Phone' },
  'field.contactEmail': { 'zh-CN': '联系人邮箱', en: 'Contact Email' },
  'field.companyName': { 'zh-CN': '公司名称', en: 'Company Name' },
  'field.companyAddress': { 'zh-CN': '公司地址', en: 'Company Address' },
  'field.position': { 'zh-CN': '职位', en: 'Position' },
  'field.income': { 'zh-CN': '收入情况', en: 'Income' },
  'field.refName': { 'zh-CN': '证明人姓名', en: 'Referee Name' },
  'field.refPosition': { 'zh-CN': '证明人职位', en: 'Referee Position' },
  'field.refPhone': { 'zh-CN': '证明人电话', en: 'Referee Phone' },
  'field.refEmail': { 'zh-CN': '证明人邮箱', en: 'Referee Email' },
  'field.name': { 'zh-CN': '姓名', en: 'Name' },
  'field.birthDate': { 'zh-CN': '出生日期', en: 'Date of Birth' },
  'field.emailContact': { 'zh-CN': '联系邮箱', en: 'Contact Email' },
  'field.phoneContact': { 'zh-CN': '联系电话', en: 'Phone Number' },
  'field.school': { 'zh-CN': '学校', en: 'School' },
  'field.major': { 'zh-CN': '专业', en: 'Major' },
  'field.rentalAddress': { 'zh-CN': '申请租房地址', en: 'Property Address' },
  'field.leaseTerm': { 'zh-CN': '期望租期', en: 'Preferred Lease Term' },
  'field.sixMonths': { 'zh-CN': '六个月', en: '6 months' },
  'field.twelveMonths': { 'zh-CN': '12个月', en: '12 months' },
  'field.longer': { 'zh-CN': '期望更长', en: 'Longer preferred' },
  'field.payRent': { 'zh-CN': '支付租金', en: 'Rent Payment' },
  'field.otherRequirements': { 'zh-CN': '其他要求', en: 'Other Requirements' },
  'field.rentalHistory': { 'zh-CN': '居住历史', en: 'Rental History' },
  'field.rentalHistoryHint': {
    'zh-CN': '* 请提供近两年内的澳洲居住信息，如未满两年请填写中国住址',
    en: '* Please provide your Australian rental history for the last two years. If less than two years, include your China address history.',
  },
  'field.financialProof': { 'zh-CN': '财务证明', en: 'Financial Proof' },
  'field.personalIncome': { 'zh-CN': '个人收入情况', en: 'Personal Income' },
  'field.personalSavings': { 'zh-CN': '个人存款情况', en: 'Personal Savings' },
  'field.familySupport': { 'zh-CN': '家庭支持情况', en: 'Family Support' },
  'field.parentSavings': { 'zh-CN': '父母存款情况', en: 'Parents Savings' },
  'field.otherAssets': {
    'zh-CN': '其他可证明租金支付能力的资产',
    en: 'Other assets proving rent-paying ability',
  },
  'field.financialHint': {
    'zh-CN': '* 以上信息需提供对应的证明文件',
    en: '* Supporting documents are required for the information above.',
  },
  'field.workHistory': { 'zh-CN': '工作经历', en: 'Work History' },
  'field.references': { 'zh-CN': '推荐人', en: 'References' },
  'field.reference1': { 'zh-CN': '推荐人 1', en: 'Reference 1' },
  'field.reference2': { 'zh-CN': '推荐人 2', en: 'Reference 2' },
  'field.relationship': { 'zh-CN': '与您的关系', en: 'Relationship to You' },
  'field.emergencyContact': { 'zh-CN': '紧急联系人', en: 'Emergency Contact' },
  'field.otherInfo': { 'zh-CN': '其他信息', en: 'Other Information' },
  'field.hasPets': { 'zh-CN': '是否有宠物？', en: 'Do you have pets?' },
  'field.yes': { 'zh-CN': '是', en: 'Yes' },
  'field.no': { 'zh-CN': '否', en: 'No' },
  'field.hasCar': { 'zh-CN': '是否有车？', en: 'Do you have a car?' },
  'field.additionalNotes': { 'zh-CN': '其他说明', en: 'Additional Notes' },
  'field.documents': { 'zh-CN': '文件材料', en: 'Documents' },
  'field.documentsHint': {
    'zh-CN': '请按以下清单准备材料，整理后发送至我们的邮箱（easyaussie.info@gmail.com）。',
    en: 'Please prepare the following documents and send them to easyaussie.info@gmail.com after organizing them.',
  },
  'field.idProof': { 'zh-CN': '身份证明', en: 'Identity Documents' },
  'field.passport': { 'zh-CN': '护照（Passport）', en: 'Passport' },
  'field.visa': { 'zh-CN': '签证（Travel Visa）', en: 'Travel Visa' },
  'field.driverLicence': { 'zh-CN': '澳洲驾照（Driver Licence）', en: 'Australian Driver Licence' },
  'field.bankStatement': {
    'zh-CN': '澳洲银行对账单（Bank Statement）',
    en: 'Australian Bank Statement',
  },
  'field.coe': { 'zh-CN': '入学确认信（CoE）', en: 'CoE' },
  'field.studentCard': { 'zh-CN': '学生卡', en: 'Student Card' },
  'field.addressProof': { 'zh-CN': '地址证明', en: 'Proof of Address' },
  'field.leaseAndReceipts': {
    'zh-CN': '租房合同及租金支付收据',
    en: 'Lease agreement and rent receipts',
  },
  'field.utilityBills': {
    'zh-CN': '水费、电费、Gas 账单',
    en: 'Water, electricity, and gas bills',
  },
  'field.depositProof': { 'zh-CN': '存款证明', en: 'Savings Proof' },
  'field.parentGuarantee': { 'zh-CN': '父母资助/保证书', en: 'Parent support / guarantee letter' },
  'field.employmentContract': { 'zh-CN': '雇佣合同', en: 'Employment Contract' },
  'field.payslips': { 'zh-CN': '工资单（近期三张）', en: 'Recent payslips (3)' },
  'field.otherMaterials': { 'zh-CN': '其他材料', en: 'Other Materials' },
  'field.otherMaterialsDesc': {
    'zh-CN': '其他有助于审核的补充材料',
    en: 'Any additional supporting materials',
  },
  'field.wechatName': { 'zh-CN': '微信名称', en: 'Contact Name' },
  'field.bookingName': { 'zh-CN': '预约姓名', en: 'Booking Name' },
  'field.propertyAddress': { 'zh-CN': '房产地址', en: 'Property Address' },
  'field.bookingTime': { 'zh-CN': '预约时间', en: 'Booking Time' },
  'field.bookingEmail': { 'zh-CN': '预约邮箱', en: 'Booking Email' },
  'field.checklist': { 'zh-CN': '检查清单', en: 'Checklist' },
  'field.pickupLocation': { 'zh-CN': '接机地点', en: 'Pickup Location' },
  'field.dropoffLocation': { 'zh-CN': '送达地点', en: 'Drop-off Location' },
  'field.passengerName': { 'zh-CN': '乘客姓名', en: 'Passenger Name' },
  'field.flightNumber': { 'zh-CN': '航班号', en: 'Flight Number' },
  'field.coverletterBasic': { 'zh-CN': '基本资料', en: 'Basic Information' },
  'field.currentLocation': { 'zh-CN': '当前居住地区', en: 'Current Location' },
  'field.visaType': { 'zh-CN': '签证类型', en: 'Visa Type' },
  'field.arrivalTime': { 'zh-CN': '（预计）来澳时间', en: 'Expected Arrival in Australia' },
  'field.stayUntil': { 'zh-CN': '预计在澳停留至', en: 'Expected Stay Until' },
  'field.personalSummary': { 'zh-CN': '个人经历概述', en: 'Personal Summary' },
  'field.workExperienceOptional': { 'zh-CN': '工作经历（如有）', en: 'Work Experience (if any)' },
  'field.startMonth': { 'zh-CN': '入职时间（月）', en: 'Start Month' },
  'field.financialStatus': { 'zh-CN': '经济状况', en: 'Financial Situation' },
  'field.prepayRent': { 'zh-CN': '预付房租意向', en: 'Prepaid Rent Preference' },
  'field.noPrepay': { 'zh-CN': '不接受预付', en: 'No prepayment' },
  'field.prepay3': { 'zh-CN': '3个月租金', en: '3 months rent' },
  'field.prepay6': { 'zh-CN': '6个月租金', en: '6 months rent' },
  'field.prepay12': { 'zh-CN': '12个月租金', en: '12 months rent' },
  'field.rentIncrease': { 'zh-CN': '可接受加租金额（每周）', en: 'Acceptable extra rent per week' },
  'field.savingsAud': {
    'zh-CN': '存款金额（澳元，需提供证明）',
    en: 'Savings (AUD, proof required)',
  },
  'field.savingsCny': {
    'zh-CN': '存款金额（人民币，需提供证明）',
    en: 'Savings (CNY, proof required)',
  },
  'field.familySupportDesc': { 'zh-CN': '家庭经济支持说明', en: 'Family Financial Support' },
  'field.assetsDesc': { 'zh-CN': '资产情况说明', en: 'Assets Description' },
  'field.rentalRecords': { 'zh-CN': '居住记录', en: 'Rental Records' },
  'field.extraInfo': { 'zh-CN': '补充信息', en: 'Additional Information' },
  'field.petInfo': { 'zh-CN': '宠物情况', en: 'Pet Information' },
  'field.smoke': { 'zh-CN': '是否吸烟', en: 'Do you smoke?' },
  'field.personalAdvantages': { 'zh-CN': '个人优势说明', en: 'Personal Strengths' },
  'field.airportFormHeading': { 'zh-CN': '填写接机信息', en: 'Fill in Pickup Details' },
  'field.airportFormDesc': {
    'zh-CN': '请准确填写以下信息，我们会安排最合适的接机服务',
    en: 'Please fill in the details accurately so we can arrange the most suitable pickup service.',
  },
  'field.airportFaq1': {
    'zh-CN': '接机服务包含什么？',
    en: 'What does the pickup service include?',
  },
  'field.airportFaq1Body': {
    'zh-CN': '包括机场迎接、行李协助、安全送达目的地等全程服务。',
    en: 'It includes airport meet-and-greet, luggage help, and safe transport to your destination.',
  },
  'field.airportFaq2': { 'zh-CN': '如果航班延误怎么办？', en: 'What if the flight is delayed?' },
  'field.airportFaq2Body': {
    'zh-CN': '我们会实时跟踪航班动态，根据最新到达时间调整接机安排。',
    en: 'We track flight status in real time and adjust pickup timing based on the latest arrival time.',
  },
  'field.airportFaq3': { 'zh-CN': '费用如何计算？', en: 'How is the price calculated?' },
  'field.airportFaq3Body': {
    'zh-CN': '根据接机距离、时间段、车型等因素综合计算，提前确认价格。',
    en: 'Pricing is based on distance, time of day, and vehicle type, with confirmation provided in advance.',
  },
};

Object.assign(messageCatalog, formFieldMessages);

const remainingVisibleMessages: Record<string, MessageDescriptor> = {
  'misc.initializing': { 'zh-CN': '初始化中...', en: 'Initializing...' },
  'misc.dashboard': { 'zh-CN': '仪表盘', en: 'Dashboard' },
  'misc.or': { 'zh-CN': '或', en: 'or' },
  'misc.cancel': { 'zh-CN': '取消', en: 'Cancel' },
  'misc.addRole': { 'zh-CN': '添加角色', en: 'Add Role' },
  'misc.currentRole': { 'zh-CN': '当前角色', en: 'Current Roles' },
  'misc.currentPassword': { 'zh-CN': '当前密码', en: 'Current Password' },
  'misc.newPassword': { 'zh-CN': '新密码', en: 'New Password' },
  'misc.confirmNewPassword': { 'zh-CN': '确认新密码', en: 'Confirm New Password' },
  'misc.passwordManagement': { 'zh-CN': '密码管理', en: 'Password Management' },
  'misc.displayName': { 'zh-CN': '显示名称', en: 'Display Name' },
  'misc.roleCode': { 'zh-CN': '角色代码', en: 'Role Code' },
  'misc.enableRole': { 'zh-CN': '启用该角色', en: 'Enable this role' },
  'misc.roleAdded': { 'zh-CN': '角色添加成功', en: 'Role added successfully' },
  'misc.roleAddFailed': { 'zh-CN': '角色添加失败', en: 'Failed to add role' },
  'misc.roleRemoved': { 'zh-CN': '角色移除成功', en: 'Role removed successfully' },
  'misc.roleRemoveFailed': { 'zh-CN': '角色移除失败', en: 'Failed to remove role' },
  'misc.passwordResetFailed': { 'zh-CN': '密码重置失败', en: 'Password reset failed' },
  'misc.passwordTooShort': {
    'zh-CN': '密码最少6位字符',
    en: 'Password must be at least 6 characters',
  },
  'misc.refreshUsersFailed': { 'zh-CN': '刷新用户列表失败', en: 'Failed to refresh user list' },
  'misc.userInfoUpdated': { 'zh-CN': '用户信息更新成功', en: 'User updated successfully' },
  'misc.userHasRole': { 'zh-CN': '用户已拥有此角色', en: 'User already has this role' },
  'misc.searchEmail': { 'zh-CN': '搜索邮箱', en: 'Search email' },
  'misc.searchName': { 'zh-CN': '搜索姓名', en: 'Search name' },
  'misc.searchPhone': { 'zh-CN': '搜索电话', en: 'Search phone' },
  'misc.searchWechat': { 'zh-CN': '搜索微信昵称', en: 'Search WeChat name' },
  'misc.searchForms': { 'zh-CN': '搜索表单...', en: 'Search forms...' },
  'misc.searchOrders': { 'zh-CN': '搜索订单...', en: 'Search orders...' },
  'misc.networkRetry': {
    'zh-CN': '请检查网络连接或稍后重试',
    en: 'Please check your network connection or try again later.',
  },
  'misc.updateFailed': { 'zh-CN': '更新失败', en: 'Update failed' },
  'misc.createdAt': { 'zh-CN': '创建时间', en: 'Created At' },
  'misc.createdAtColon': { 'zh-CN': '创建时间:', en: 'Created At:' },
  'misc.updatedAtColon': { 'zh-CN': '更新时间:', en: 'Updated At:' },
  'misc.orderInfo': { 'zh-CN': '订单信息', en: 'Order Info' },
  'misc.orderList': { 'zh-CN': '订单列表', en: 'Order List' },
  'misc.orderDetail': { 'zh-CN': '订单详情', en: 'Order Details' },
  'misc.orderTitle': { 'zh-CN': '订单标题', en: 'Order Title' },
  'misc.orderTypeColon': { 'zh-CN': '订单类型:', en: 'Order Type:' },
  'misc.orderStatusColon': { 'zh-CN': '订单状态:', en: 'Order Status:' },
  'misc.formDetail': { 'zh-CN': '表单详情', en: 'Form Details' },
  'misc.formInfo': { 'zh-CN': '表单信息', en: 'Form Info' },
  'misc.relatedFiles': { 'zh-CN': '相关文件', en: 'Related Files' },
  'misc.remarkInfo': { 'zh-CN': '备注信息', en: 'Notes' },
  'misc.serviceOrder': { 'zh-CN': '服务订单', en: 'Service Order' },
  'misc.serviceExplanation': { 'zh-CN': '服务说明：', en: 'Service note:' },
  'misc.unsupportedFormDetail': {
    'zh-CN': '该表单类型暂不支持详细解析，请联系客服查看详情。',
    en: 'Detailed parsing is not currently supported for this form type. Please contact support for details.',
  },
  'misc.wechatNameColon': { 'zh-CN': '微信名称:', en: 'Contact Name:' },
  'misc.bookingNameColon': { 'zh-CN': '预约姓名:', en: 'Booking Name:' },
  'misc.propertyAddressColon': { 'zh-CN': '房产地址:', en: 'Property Address:' },
  'misc.bookingTimeColon': { 'zh-CN': '预约时间:', en: 'Booking Time:' },
  'misc.bookingEmailColon': { 'zh-CN': '预约邮箱:', en: 'Booking Email:' },
  'misc.phoneColon': { 'zh-CN': '联系电话:', en: 'Phone:' },
  'misc.checklistColon': { 'zh-CN': '检查清单:', en: 'Checklist:' },
  'misc.pickupLocationColon': { 'zh-CN': '接机地点:', en: 'Pickup Location:' },
  'misc.dropoffLocationColon': { 'zh-CN': '送达地点:', en: 'Drop-off Location:' },
  'misc.pickupTimeColon': { 'zh-CN': '接机时间:', en: 'Pickup Time:' },
  'misc.passengerNameColon': { 'zh-CN': '乘客姓名:', en: 'Passenger Name:' },
  'misc.flightNoColon': { 'zh-CN': '航班号:', en: 'Flight Number:' },
  'misc.emailColon': { 'zh-CN': '邮箱:', en: 'Email:' },
  'misc.nameColon': { 'zh-CN': '姓名:', en: 'Name:' },
  'misc.phoneLabelColon': { 'zh-CN': '电话:', en: 'Phone:' },
  'misc.wechatColon': { 'zh-CN': '微信昵称:', en: 'Contact Name:' },
  'misc.currentStatusColon': { 'zh-CN': '当前状态:', en: 'Current Status:' },
  'misc.purposeName': { 'zh-CN': '目的地地址', en: 'Destination Address' },
  'misc.estimatedPickup': { 'zh-CN': '预计接机时间', en: 'Estimated Pickup Time' },
  'misc.luggageInfo': { 'zh-CN': '行李数量及尺寸', en: 'Luggage Count and Size' },
  'misc.enterWechatName': { 'zh-CN': '请输入您的微信名称', en: 'Enter your Contact name' },
  'misc.enterPhone': { 'zh-CN': '请输入您的联系电话', en: 'Enter your phone number' },
  'misc.enterBookingEmail': {
    'zh-CN': '请输入预约时使用的邮箱',
    en: 'Enter the email used for booking',
  },
  'misc.enterAmount': { 'zh-CN': '请输入金额', en: 'Enter an amount' },
  'misc.fillIn': { 'zh-CN': '请填写', en: 'Please fill in' },
  'misc.enterChecklist': {
    'zh-CN': '请输入需要重点检查的事项',
    en: 'Enter the key items you want checked',
  },
  'misc.maxInspectionChecklist': {
    'zh-CN': '最多5项，每项50字符',
    en: 'Up to 5 items, 50 characters each',
  },
  'misc.max5InspectionItems': {
    'zh-CN': '最多只能添加5个检查项',
    en: 'You can add up to 5 checklist items.',
  },
  'misc.max5RentalHistory': {
    'zh-CN': '最多只能添加5条居住历史',
    en: 'You can add up to 5 rental history entries.',
  },
  'misc.max3WorkHistory': {
    'zh-CN': '最多只能添加3条工作经历',
    en: 'You can add up to 3 work history entries.',
  },
  'misc.workHistoryAdded': { 'zh-CN': '已添加工作经历', en: 'Work history added' },
  'misc.rentalHistoryAdded': { 'zh-CN': '已添加居住历史', en: 'Rental history added' },
  'misc.itemDeleted': { 'zh-CN': '已删除项目', en: 'Item removed' },
  'misc.unitName': { 'zh-CN': '单位名称', en: 'Employer Name' },
  'misc.livingAddress': { 'zh-CN': '居住地址', en: 'Residential Address' },
  'misc.livingType': { 'zh-CN': '居住类型', en: 'Residential Type' },
  'misc.livingDates': { 'zh-CN': '居住起止时间', en: 'Residence Dates' },
  'misc.startTime': { 'zh-CN': '开始时间', en: 'Start Time' },
  'misc.endTime': { 'zh-CN': '结束时间', en: 'End Time' },
  'misc.additionalNotes': { 'zh-CN': '补充说明', en: 'Additional Notes' },
  'misc.commonAirportService': { 'zh-CN': '机场接机服务', en: 'Airport Pickup Service' },
  'misc.airportTransfer': { 'zh-CN': '机场接送', en: 'Airport Transfer' },
  'misc.airportTransferService': { 'zh-CN': '机场接送服务', en: 'Airport Transfer Service' },
  'misc.pickupService': { 'zh-CN': '接机服务', en: 'Pickup Service' },
  'misc.inspectionService': { 'zh-CN': '房屋检查服务', en: 'Inspection Service' },
  'misc.inspection': { 'zh-CN': '房屋检查', en: 'Inspection' },
  'misc.testService': { 'zh-CN': '测试服务', en: 'Test Service' },
  'misc.coverletterService': { 'zh-CN': '租房申请信服务', en: 'Cover Letter Service' },
  'misc.jobLetter': { 'zh-CN': '租房申请信', en: 'Cover Letter' },
  'misc.unknownLocation': { 'zh-CN': '未知地点', en: 'Unknown location' },
  'misc.airportHero': {
    'zh-CN': '专业司机，安全舒适，让您的澳洲之旅从温暖的接机开始',
    en: 'Professional drivers, safe and comfortable, so your Australian journey starts with a warm welcome.',
  },
};

Object.assign(messageCatalog, remainingVisibleMessages);

const finalVisibleMessages: Record<string, MessageDescriptor> = {
  'final.editUser': { 'zh-CN': '编辑用户', en: 'Edit User' },
  'final.contactEasy': { 'zh-CN': '便于我们联系您', en: 'This helps us contact you' },
  'final.passwordAdvice': {
    'zh-CN': '定期更新密码以保护账户安全',
    en: 'Update your password regularly to keep your account secure.',
  },
  'final.adminTitle': { 'zh-CN': '管理中心 - Easy Aussie', en: 'Admin Center - Easy Aussie' },
  'final.loadFailed': { 'zh-CN': '加载失败', en: 'Load failed' },
  'final.suggestions': { 'zh-CN': '建议', en: 'Suggestions' },
  'final.role': { 'zh-CN': '角色', en: 'Role' },
  'final.disableUser': { 'zh-CN': '禁用用户', en: 'Disable User' },
  'final.enableUser': { 'zh-CN': '启用用户', en: 'Enable User' },
  'final.contactColon': { 'zh-CN': '联系方式:', en: 'Contact:' },
  'final.leaveBlankPassword': {
    'zh-CN': '留空则不修改密码',
    en: 'Leave blank to keep the current password',
  },
  'final.other': { 'zh-CN': '其他', en: 'Other' },
  'final.addRoleSelect': { 'zh-CN': '选择要添加的角色', en: 'Select a role to add' },
  'final.pickType': { 'zh-CN': '选择租房类型', en: 'Select rental type' },
  'final.studentApartmentShort': { 'zh-CN': '学生公寓', en: 'Student Apartment' },
  'final.userInfo': { 'zh-CN': '用户信息', en: 'User Information' },
  'final.email': { 'zh-CN': '邮箱', en: 'Email' },
  'final.registeredAtColon': { 'zh-CN': '注册时间:', en: 'Registered At:' },
  'final.lastModified': { 'zh-CN': '最后修改', en: 'Last Modified' },
  'final.min6Chars': { 'zh-CN': '最少6位字符', en: 'At least 6 characters' },
  'final.modifyPassword': { 'zh-CN': '修改密码', en: 'Change Password' },
  'final.deleteAccount': { 'zh-CN': '账户注销', en: 'Delete Account' },
  'final.phoneSupport': { 'zh-CN': '', en: '' },
  'final.emailSupport': {
    'zh-CN': '邮箱: easyaussie.info@gmail.com',
    en: 'Email: easyaussie.info@gmail.com',
  },
  'final.wechatSupport': { 'zh-CN': '微信: Easy-Aussie', en: 'WeChat: Easy-Aussie' },
  'final.toWord': { 'zh-CN': '至', en: 'to' },
  'final.coverletterHeading': {
    'zh-CN': '租房申请信信息填写',
    en: 'Cover Letter Information',
  },
  'final.rentalApplicationForm': {
    'zh-CN': '租房申请信息填写',
    en: 'Rental Application Information',
  },
  'final.airportPickupFaqHeading': { 'zh-CN': '填写预约信息', en: 'Fill in Booking Details' },
  'final.airportPickupFaqDesc': {
    'zh-CN': '请准确填写以下信息，我们会根据您的需求安排看房',
    en: 'Please fill in the details accurately and we will arrange the viewing according to your needs.',
  },
  'final.coverletterDesc': {
    'zh-CN': '请填写以下信息，我们将为您撰写规范的租房求租信',
    en: 'Please provide the information below and we will write a clear, professional rental cover letter for you.',
  },
  'final.additionalInfoHelp': {
    'zh-CN': '请提供任何其他相关信息，这将有助于我们更好地为您服务',
    en: 'Please provide any other relevant information so we can support you better.',
  },
  'final.petInfoPlaceholder': {
    'zh-CN': '请说明宠物情况（包括姓名、类型、品种、体型等）',
    en: 'Describe your pet details, including name, type, breed, and size.',
  },
  'final.carPlatePlaceholder': { 'zh-CN': '请填写车牌号码', en: 'Enter your licence plate number' },
  'final.notesPlaceholder': { 'zh-CN': '请备注', en: 'Add notes' },
  'final.roleExampleAdmin': { 'zh-CN': '例如：管理员', en: 'e.g. Administrator' },
  'final.roleExampleCode': { 'zh-CN': '例如：admin', en: 'e.g. admin' },
  'final.roleExampleIcon': { 'zh-CN': '例如：fas fa-user', en: 'e.g. fas fa-user' },
  'final.roleExampleColor': { 'zh-CN': '例如：#2563eb', en: 'e.g. #2563eb' },
  'final.rentalRelationPlaceholder': {
    'zh-CN': '例如：房东/中介/其他请说明',
    en: 'e.g. landlord / agent / other',
  },
  'final.coverletterExampleAssets': { 'zh-CN': '如：车、房等', en: 'e.g. car, property, etc.' },
  'final.coverletterExampleSupport': {
    'zh-CN': '如：每月父母补贴',
    en: 'e.g. monthly support from parents',
  },
  'final.flightExample': { 'zh-CN': '如：CZ325', en: 'e.g. CZ325' },
  'final.addressExample': {
    'zh-CN': '例如: 35 Stirling Hwy, Crawley WA 6009',
    en: 'e.g. 35 Stirling Hwy, Crawley WA 6009',
  },
  'final.luggageExample': {
    'zh-CN': '例：28寸箱子 ×2 个，24寸箱子 ×1 个',
    en: 'e.g. 2 x 28-inch suitcases, 1 x 24-inch suitcase',
  },
  'final.fullNameHint': {
    'zh-CN': 'Full Name, 不确定可检查预约邮件抬头',
    en: 'Full Name. If unsure, check the greeting line in your booking email.',
  },
  'final.seeDetails': { 'zh-CN': '点击查看详情', en: 'Click to view details' },
  'final.bookInspectionButton': {
    'zh-CN': '点击 Book Inspection / Add to Plan',
    en: 'Click Book Inspection / Add to Plan',
  },
  'final.guideLine1': {
    'zh-CN': '大多数中介要求先看房，后申请。',
    en: 'Most agents require you to inspect first and apply afterwards.',
  },
  'final.guideLine2': {
    'zh-CN': '房源已提前选定租客，看房被取消',
    en: 'A renter may already have been selected and the inspection could be cancelled.',
  },
  'final.guideLine3': {
    'zh-CN': '各类原因导致中介迟到或延误',
    en: 'The agent may arrive late or be delayed for various reasons.',
  },
  'final.guideLine4': {
    'zh-CN': '看房时重点关注房屋实际状况，避免图文不符',
    en: 'Focus on the actual condition during inspections to avoid surprises.',
  },
  'final.guideLine5': {
    'zh-CN': '留意周边环境，是否存在噪音等影响居住的问题',
    en: 'Pay attention to the surrounding area and any issues such as noise.',
  },
  'final.guideLine6': {
    'zh-CN': '同时预约多套房源，避免突发情况影响整体进度',
    en: 'Book multiple inspections to reduce the impact of unexpected changes.',
  },
  'final.guideLine7': {
    'zh-CN': '在澳洲，常用的租房平台包括：',
    en: 'Common rental platforms in Australia include:',
  },
  'final.guideLine8': {
    'zh-CN': '这两个平台房源更新较快，也是多数中介发布看房信息和接收申请的主要渠道。',
    en: 'These platforms update listings quickly and are the main channels agents use for inspections and applications.',
  },
  'final.guideLine9': {
    'zh-CN': '找房准备时间会因市场情况有所不同，一般建议如下：',
    en: 'Preparation time varies with the market, but a common recommendation is:',
  },
  'final.guideLine10': {
    'zh-CN': '普通时期：提前 2-3 周开始准备',
    en: 'Normal periods: start preparing 2-3 weeks in advance',
  },
  'final.guideLine11': {
    'zh-CN': '高峰期（如开学季）：提前 3-5 周开始准备',
    en: 'Peak periods such as semester start: begin 3-5 weeks in advance',
  },
  'final.guideLine12': {
    'zh-CN': '提前准备有助于更从容地筛选房源、安排看房并准备申请材料。',
    en: 'Preparing early helps you shortlist properties, arrange inspections, and prepare application materials more calmly.',
  },
  'final.guideLine13': {
    'zh-CN': '提交后中介会核对材料与条件，必要时联系补充信息。',
    en: 'After submission, agents review your documents and may contact you for additional information.',
  },
  'final.guideLine14': {
    'zh-CN': '审核通过后将发送租约，确认条款并签署后即可办理入住。',
    en: 'Once approved, the lease will be sent to you. After confirming the terms and signing, you can arrange move-in.',
  },
  'final.guideLine15': {
    'zh-CN': '在正常情况下，中介通常会在 1-5 个工作日内给出反馈。',
    en: 'Under normal circumstances, agents usually respond within 1-5 business days.',
  },
  'final.guideLine16': {
    'zh-CN': '如房源安排多次看房，或申请材料需要进一步审核，回复时间可能会相应延长。',
    en: 'If a property has multiple inspection rounds or the application needs extra review, the response time may be longer.',
  },
  'final.guideLine17': {
    'zh-CN': '并非所有中介都会逐一通知未成功的申请人。',
    en: 'Not every agent notifies unsuccessful applicants individually.',
  },
  'final.guideLine18': {
    'zh-CN':
      '如果曾与中介保持邮件沟通，且申请材料准备完整，通常更有可能收到回复，或被推荐其他合适房源。',
    en: 'If you have maintained email contact and submitted a complete application, you are more likely to receive a reply or be recommended other suitable listings.',
  },
  'final.guideLine19': {
    'zh-CN':
      '是否允许养宠物取决于房东的具体政策。部分房源明确不接受宠物，但也有房东在看到租客稳定、负责的资料后，愿意重新考虑。',
    en: 'Whether pets are allowed depends on the landlord. Some listings clearly do not allow pets, while others may reconsider after seeing a strong application.',
  },
  'final.guideLine20': {
    'zh-CN': '如有宠物，建议在申请材料中主动说明宠物情况及责任意识，以便房东全面评估。',
    en: 'If you have pets, proactively explain the pet details and your sense of responsibility in the application.',
  },
  'final.guideLine21': {
    'zh-CN': '在固定租约期内，租金一般不会调整。',
    en: 'Rent usually does not change during a fixed lease term.',
  },
  'final.guideLine22': {
    'zh-CN': '在续约或转为周期租约时，房东可能会根据市场情况重新评估租金。',
    en: 'At renewal or when moving to a periodic lease, the landlord may reassess the rent based on market conditions.',
  },
  'final.guideLine23': {
    'zh-CN': '保持良好租住记录的租客，在续约阶段通常具备更好的沟通空间。',
    en: 'Renters with a good tenancy record usually have more room to negotiate at renewal.',
  },
  'final.guideLine24': {
    'zh-CN': '预约完成后，可在 App 底部 Collections → Inspections 中确认状态',
    en: 'After booking, you can confirm the status in Collections → Inspections in the app.',
  },
  'final.guideLine25': {
    'zh-CN': '填写姓名、邮箱及电话即可预约（没有澳洲电话可暂不填写）',
    en: 'Enter your name, email, and phone number to book. An Australian phone number can be left blank if unavailable.',
  },
  'final.guideLine26': {
    'zh-CN': '预约方式（以 Realestate 为例）',
    en: 'How to book inspections (using Realestate as an example)',
  },
  'final.rednote': { 'zh-CN': '小红书', en: 'RedNote' },
  'final.serviceRequest': { 'zh-CN': '申请服务', en: 'Application Service' },
  'final.rentalApplicationService': { 'zh-CN': '租房申请服务', en: 'Rental Application Service' },
  'final.totalOrders': { 'zh-CN': '总订单数', en: 'Total Orders' },
  'final.profileLoadFailed': {
    'zh-CN': '无法加载个人中心内容，请检查网络连接或稍后重试',
    en: 'Unable to load profile content. Please check your connection or try again later.',
  },
};

Object.assign(messageCatalog, finalVisibleMessages);

const fullCoverageMessages: Record<string, MessageDescriptor> = {
  'fullCoverage.enterEmail': {
    'zh-CN': '请输入邮箱地址',
    en: 'Enter your email address',
  },
  'fullCoverage.enterCaptcha': {
    'zh-CN': '请输入验证码',
    en: 'Enter the captcha',
  },
  'fullCoverage.userLogin': {
    'zh-CN': '用户登录',
    en: 'User Sign In',
  },
  'fullCoverage.welcomeBackEasyAussie': {
    'zh-CN': '欢迎回到 Easy Aussie',
    en: 'Welcome back to Easy Aussie',
  },
  'fullCoverage.clickRefreshCaptcha': {
    'zh-CN': '点击刷新验证码',
    en: 'Click to refresh the captcha',
  },
  'fullCoverage.rentalApplication': {
    'zh-CN': '租房申请',
    en: 'Rental Application',
  },
  'fullCoverage.privateLandlordShort': {
    'zh-CN': '房东直租',
    en: 'Private Landlord',
  },
  'fullCoverage.agentRentalShort': {
    'zh-CN': '中介租房',
    en: 'Agency Rental',
  },
  'fullCoverage.specialNoteLabel': {
    'zh-CN': '特殊说明：',
    en: 'Special note:',
  },
  'fullCoverage.kindReminderLabel': {
    'zh-CN': '温馨提示：',
    en: 'Friendly reminder:',
  },
  'fullCoverage.inspectionBookingService': {
    'zh-CN': '预约看房服务',
    en: 'Property Viewing Service',
  },
  'fullCoverage.inspectionBookingSubtitle': {
    'zh-CN': '专业团队代您实地看房，详细反馈房屋情况',
    en: 'Our team attends the viewing for you and provides detailed feedback on the property.',
  },
  'fullCoverage.applicationIntro': {
    'zh-CN': '请详细填写申请信息，我们将协助您递交完整的租房申请',
    en: 'Please provide detailed application information and we will help you submit a complete rental application.',
  },
  'fullCoverage.enterRentalAddress': {
    'zh-CN': '请填写意向房源地址',
    en: 'Enter the property address you want to apply for',
  },
  'fullCoverage.workExperienceExample': {
    'zh-CN': '例如：工作经历、海外生活经历',
    en: 'For example: work experience, overseas living experience',
  },
  'fullCoverage.petTypeAndCount': {
    'zh-CN': '如有请说明种类与数量',
    en: 'If applicable, describe the type and quantity',
  },
  'fullCoverage.airportSpecialRequirement': {
    'zh-CN': '如有特殊要求请在此说明，如儿童安全座椅、轮椅通道等',
    en: 'List any special requirements here, such as a child safety seat or wheelchair access.',
  },
  'fullCoverage.inspectionTips': {
    'zh-CN': '看房注意事项',
    en: 'Viewing Tips',
  },
  'fullCoverage.agentRescheduleInspection': {
    'zh-CN': '中介临时更改看房时间',
    en: 'The agent changes the inspection time at short notice',
  },
  'fullCoverage.coverletterExplanation': {
    'zh-CN':
      'Cover Letter（租房求租信）是租客在提交租房申请时附带的一封简短说明信，用于向中介或房东介绍自身情况，并补充申请表中难以充分体现的信息。',
    en: 'A Cover Letter is a short letter attached to a rental application to introduce the renter to the agent or landlord and add details that are hard to show fully in the application form.',
  },
  'fullCoverage.coverletterExplanationFollowup': {
    'zh-CN':
      '通常包括租客背景、居住计划、经济能力以及生活习惯等内容，一封清晰、规范的租房申请信有助于申请材料被更好地理解和评估。',
    en: 'It usually includes the renter’s background, living plans, financial capacity, and lifestyle habits. A clear and professional Cover Letter helps the application be understood and assessed more effectively.',
  },
  'fullCoverage.submittedAt': {
    'zh-CN': '提交时间',
    en: 'Submitted At',
  },
  'fullCoverage.deleteUser': {
    'zh-CN': '删除用户',
    en: 'Delete User',
  },
  'fullCoverage.selectRoleToAdd': {
    'zh-CN': '请选择要添加的角色',
    en: 'Please select a role to add',
  },
  'fullCoverage.orderIdLabel': {
    'zh-CN': '订单号:',
    en: 'Order ID:',
  },
  'fullCoverage.otherServices': {
    'zh-CN': '其他服务',
    en: 'Other Services',
  },
  'fullCoverage.orderSupportHint': {
    'zh-CN': '如需取消订单或有任何疑问，请联系客服：',
    en: 'If you need to cancel an order or have any questions, please contact support:',
  },
  'fullCoverage.enterFullName': {
    'zh-CN': '请输入真实姓名',
    en: 'Enter your full name',
  },
  'fullCoverage.profileNameHint': {
    'zh-CN': '显示在您的个人资料中',
    en: 'Shown on your profile',
  },
  'fullCoverage.enterWechatNickname': {
    'zh-CN': '请输入微信昵称',
    en: 'Enter your WeChat nickname',
  },
  'fullCoverage.emailCannotChange': {
    'zh-CN': '邮箱地址不能修改',
    en: 'Your email address cannot be changed',
  },
  'fullCoverage.enterPhone': {
    'zh-CN': '请输入联系电话',
    en: 'Enter your phone number',
  },
  'fullCoverage.phoneSupportHint': {
    'zh-CN': '用于紧急联系和服务通知',
    en: 'Used for urgent contact and service updates',
  },
  'fullCoverage.deleteAccountHint': {
    'zh-CN': '永久删除账户和所有相关数据',
    en: 'Permanently delete your account and all related data',
  },
  'fullCoverage.enterCurrentPassword': {
    'zh-CN': '请输入当前密码',
    en: 'Enter your current password',
  },
  'fullCoverage.enterNewPassword': {
    'zh-CN': '请输入新密码',
    en: 'Enter your new password',
  },
  'fullCoverage.confirmNewPasswordPlaceholder': {
    'zh-CN': '请再次输入新密码',
    en: 'Enter your new password again',
  },
  'fullCoverage.mobileInspectionCardDesc': {
    'zh-CN': '专业代看房服务，实地拍摄视频，详细反馈房屋情况',
    en: 'Professional viewing assistance with on-site video and detailed property feedback.',
  },
  'fullCoverage.mobileCoverletterCardDesc': {
    'zh-CN': '量身定制英文求租信，提升申请成功率',
    en: 'Tailored English rental cover letters to improve your application success rate.',
  },
  'fullCoverage.mobileApplicationCardDesc': {
    'zh-CN': '全程代办申请流程，材料准备，提高成功率',
    en: 'End-to-end application handling, document preparation, and stronger submission quality.',
  },
  'fullCoverage.mobilePickupCardDesc': {
    'zh-CN': '安全便捷的接机安排，让您落地无忧',
    en: 'Safe and convenient pickup arrangements so you can arrive without stress.',
  },
  'fullCoverage.pricePerLetter3': {
    'zh-CN': '$3/封',
    en: '$3 / letter',
  },
  'fullCoverage.pricePerApplication5': {
    'zh-CN': '$5/封',
    en: '$5 / application',
  },
  'fullCoverage.pricePerTrip50': {
    'zh-CN': '$50/次',
    en: '$50 / trip',
  },
  'fullCoverage.fetchRolesFailed': {
    'zh-CN': '获取角色列表失败',
    en: 'Failed to get the role list',
  },
  'fullCoverage.fetchManageableRolesFailed': {
    'zh-CN': '获取可管理角色失败',
    en: 'Failed to get manageable roles',
  },
  'fullCoverage.createRoleFailed': {
    'zh-CN': '创建角色失败',
    en: 'Failed to create role',
  },
  'fullCoverage.updateRoleFailed': {
    'zh-CN': '更新角色失败',
    en: 'Failed to update role',
  },
  'fullCoverage.deleteRoleFailed': {
    'zh-CN': '删除角色失败',
    en: 'Failed to delete role',
  },
  'fullCoverage.assignRoleFailed': {
    'zh-CN': '分配角色失败',
    en: 'Failed to assign role',
  },
  'fullCoverage.removeRoleFailed': {
    'zh-CN': '移除角色失败',
    en: 'Failed to remove role',
  },
  'fullCoverage.bulkUpdateRolesFailed': {
    'zh-CN': '批量更新用户角色失败',
    en: 'Failed to update user roles in bulk',
  },
};

Object.assign(messageCatalog, fullCoverageMessages);

const dynamicTemplateMessages: Record<string, MessageDescriptor> = {
  'dynamic.popularService': { 'zh-CN': '热门服务', en: 'Popular Service' },
  'dynamic.phoneConsultation': { 'zh-CN': '电话咨询', en: 'Phone Consultation' },
  'dynamic.bookOnline': { 'zh-CN': '在线预约', en: 'Book Online' },
  'dynamic.signInAccount': { 'zh-CN': '登录账号', en: 'Sign In' },
  'dynamic.specialNoteBody': {
    'zh-CN': '中介或房东取消看房时，同样按以上规定处理；若中介迟到,可等待10分钟。',
    en: 'If the agent or landlord cancels the viewing, the same policy applies; if the agent is late, please allow 10 minutes.',
  },
  'dynamic.kindReminderBody': {
    'zh-CN': '由于中介接待租客较多（部分房源超过20组），请确保问题简洁明了。',
    en: 'Agents may be hosting many groups, so please keep your questions concise.',
  },
  'dynamic.basicInspectionNoteBody': {
    'zh-CN': '本服务为基础代看，不提供专业验房报告。如需入住前房屋检查，属于不同服务类别。',
    en: 'This is a basic viewing assistance service and does not include a professional inspection report. Pre-move-in property checks are a separate service.',
  },
  'dynamic.checklistTitle': { 'zh-CN': '重点检查事项', en: 'Key Inspection Items' },
  'dynamic.addChecklistItem': { 'zh-CN': '添加检查项', en: 'Add Checklist Item' },
  'dynamic.saveChanges': { 'zh-CN': '保存更改', en: 'Save Changes' },
  'dynamic.refreshData': { 'zh-CN': '刷新数据', en: 'Refresh Data' },
  'dynamic.confirmUpdate': { 'zh-CN': '确认修改', en: 'Confirm Changes' },
  'dynamic.autoFilledFromAccount': {
    'zh-CN': '信息已从您的登录账户自动填充',
    en: 'Information has been auto-filled from your sign-in account',
  },
  'dynamic.closeAccount': { 'zh-CN': '注销账户', en: 'Close Account' },
  'dynamic.createOrder': { 'zh-CN': '创建订单', en: 'Create Order' },
  'dynamic.cancelOrderPrompt': { 'zh-CN': '需要取消订单？', en: 'Need to cancel an order?' },
  'dynamic.add': { 'zh-CN': '添加', en: 'Add' },
};

Object.assign(messageCatalog, dynamicTemplateMessages);

const staticHtmlMessages: Record<string, MessageDescriptor> = {
  'static.and': { 'zh-CN': '和', en: 'and' },
  'static.exploreServices': { 'zh-CN': '探索服务', en: 'Explore Services' },
  'static.getStartedNow': { 'zh-CN': '立即开始', en: 'Get Started' },
  'static.bookServiceNow': { 'zh-CN': '立即预约服务', en: 'Book a Service Now' },
  'static.createAccount': { 'zh-CN': '注册账户', en: 'Create Account' },
  'static.homeHighlight1': {
    'zh-CN': '深耕珀斯租房市场，提供专业、客观的看房反馈',
    en: 'Deeply focused on the Perth rental market, with professional and objective viewing feedback.',
  },
  'static.homeHighlight2': {
    'zh-CN': '以租客委托为核心，流程清晰，服务稳定',
    en: 'Built around renter-side support, with clear processes and dependable service.',
  },
  'static.homeCtaDesc': {
    'zh-CN': '专业团队随时为您服务，让租房变得简单轻松',
    en: 'Our team is ready to help anytime, making renting simpler and easier.',
  },
  'static.contactNow': { 'zh-CN': '立即咨询', en: 'Contact Us Now' },
  'static.back': { 'zh-CN': '返回', en: 'Back' },
  'static.submitApplicationInfo': { 'zh-CN': '提交申请信息', en: 'Submit Application Details' },
  'static.submitRentalApplication': { 'zh-CN': '提交租房申请', en: 'Submit Rental Application' },
  'static.addWorkHistory': { 'zh-CN': '添加工作经历', en: 'Add Work Experience' },
  'static.addRentalHistory': { 'zh-CN': '添加居住历史', en: 'Add Rental History' },
  'static.addRentalRecord': { 'zh-CN': '新增居住记录', en: 'Add Rental Record' },
  'static.coverletterTurnaround': {
    'zh-CN': '提交后我们将在24小时内为您准备专业的租房申请信',
    en: 'After submission, we will prepare a professional Cover Letter for you within 24 hours.',
  },
  'static.applicationFollowup': {
    'zh-CN': '提交申请后，我们的专业团队将在24小时内联系您，协助您完成租房申请流程',
    en: 'After you submit, our team will contact you within 24 hours to help complete your rental application.',
  },
  'static.viewApplicationStatus': { 'zh-CN': '查看申请状态', en: 'View Application Status' },
  'static.waitForUpdates': {
    'zh-CN': '请耐心等待后续通知',
    en: 'Please wait patiently for further updates',
  },
  'static.processingSubmission': {
    'zh-CN': '我们已收到您的提交，正在进入处理流程',
    en: 'We have received your submission and it is now entering the processing workflow.',
  },
  'static.submitFailedApology': {
    'zh-CN': '很抱歉，提交未成功',
    en: 'Sorry, your submission was not successful',
  },
  'static.submitFailedContact': {
    'zh-CN': '请直接联系工作人员协助处理，我们将尽快为您解决',
    en: 'Please contact our staff directly and we will help resolve it as soon as possible.',
  },
  'static.resubmitApplication': { 'zh-CN': '重新提交申请', en: 'Resubmit Application' },
  'static.contactLine': {
    'zh-CN': '邮箱：easyaussie.info@gmail.com | 微信：Easy-Aussie',
    en: 'Email: easyaussie.info@gmail.com | WeChat: Easy-Aussie',
  },
  'static.unauthorizedAccess': {
    'zh-CN': '当前账号暂无访问权限',
    en: 'Your current account does not have access permission',
  },
  'static.contactAdminAccess': {
    'zh-CN': '请联系管理员为您开通相应权限',
    en: 'Please contact the administrator to grant the required access.',
  },
  'static.loginAgreementLead': {
    'zh-CN': '登录即表示您同意我们的',
    en: 'By signing in, you agree to our',
  },
  'static.registerAgreementLead': {
    'zh-CN': '注册即表示您同意我们的',
    en: 'By signing up, you agree to our',
  },
  'static.bookService': { 'zh-CN': '预约服务', en: 'Book a Service' },
  'static.guideQuestionPlatforms': {
    'zh-CN': '一般在哪里选房？',
    en: 'Where do people usually search for rentals?',
  },
  'static.guideQuestionTiming': {
    'zh-CN': '提前多久开始准备找房比较合适？',
    en: 'How early should I start preparing to rent?',
  },
  'static.guideQuestionReply': {
    'zh-CN': '租房申请递交后，一般多久中介会给答复？',
    en: 'After a rental application is submitted, how long does an agent usually take to reply?',
  },
  'static.guideQuestionRejectNotice': {
    'zh-CN': '如果申请未成功，中介是否会通知？',
    en: 'If an application is unsuccessful, will the agent notify me?',
  },
  'static.guideQuestionPets': {
    'zh-CN': '是否允许养宠物？如果不允许，有没有协商空间？',
    en: 'Are pets allowed? If not, is there any room to negotiate?',
  },
  'static.guideQuestionRentIncrease': {
    'zh-CN': '租期内租金是否有可能调整？',
    en: 'Can the rent change during the lease term?',
  },
  'static.guideQuestionCoverletter': {
    'zh-CN': '租房申请信是什么？',
    en: 'What is a Cover Letter?',
  },
};

Object.assign(messageCatalog, staticHtmlMessages);
